import {
  ACCOUNT_UPDATE_ENDPOINT,
  CANCEL_APPOINTMENT_ENDPOINT,
  CITY_LIST_CONFIG,
  COMMUNITY_HIGHLIGHTS_ENDPOINT,
  COMMUNITY_UPDATE_ENDPOINT,
  CONSTRUCTION_UPDATE_ENDPOINT,
  CREATE_PAYMENT_ENDPOINT,
  CREATE_SERVICE_FEE_ENDPOINT,
  CREATE_UPDATE_APPOINTMENT_ENDPOINT,
  CUSTOMER_MANAGMENT_FEE_ENDPOINT,
  CUSTOMER_MANAGMENT_FEE_STATUS_ENDPOINT,
  DOCUMENTS_BY_CUSTOMER_ID_ENDPOINT,
  DOCUMENTS_BY_DOCUMENT_ID_ENDPOINT,
  DOCUSIGN_ENDPOINT,
  EMPTY_PROPERTIES_ENDPOINT,
  FAQ_ENDPOINT,
  FINANCIAL_STATEMENTS_ENDPOINT,
  GENERATE_SOA_ENDPOINT,
  GET_APPOINTMENT_AVAILABLE_DATES_ENDPOINT,
  GET_APPOINTMENT_AVAILABLE_SLOTS_ENDPOINT,
  GET_SALES_MANAGER_LIST_ENDPOINT,
  GET_USER_DETAILS_ENDPOINT,
  GLOBAL_CONFIG_ENDPOINT,
  GLOBAL_SEARCH_ENDPOINT,
  HOME_ENDPOINT,
  LEAD_CONVERT_ENDPOINT,
  LEAD_CREATE_ENDPOINT,
  LEAD_ELIGIBILITY_ENDPOINT,
  LEAD_VERIFY_ENDPOINT,
  NEWS_DETAILS_ENDPOINT,
  NEWS_EVENTS_ENDPOINT,
  NEWS_LISTING_ENDPOINT,
  NOTIFICATIONS_HISTORY_ENDPOINT,
  OPPORTUNITY_UPDATE_ENDPOINT,
  OPPORTUNITY_VERIFY_ENDPOINT,
  PAYMENT_DATA_ENDPOINT,
  PAYMENT_RECEIPT_ENDPOINT,
  PAYMENT_STATUS_DETAILS_ENDPOINT,
  PERFORMA_INVOICE_ENDPOINT,
  PROJECT_DETAILS_ENDPOINT,
  PROJECT_IMAGES_SEARCH_ENDPOINT,
  PROPERTY_JOURNEYS_ENDPOINT,
  PROPERTY_JOURNEY_ENDPOINT,
  READ_NOTIFICATIONS_ENDPOINT,
  SALES_ORDER_DETAILS_ENDPOINT,
  SAVE_DEVICE_DETAILS_ENDPOINT,
  CREATE_HANDOFF_ENDPOINT,
  SERVICE_FEE_ENDPOINT,
  SERVICE_FEE_FILTER_OPTIONS_ENDPOINT,
  SERVICE_REQUEST_CREATION_ENDPOINT,
  SERVICE_REQUEST_ELIGIBILITY_ENDPOINT,
  SERVICE_REQUEST_SEARCH_ENDPOINT,
  SET_REMINDER_ENDPOINT,
  STATEMENTS_DATA_ENDPOINT,
  UPDATE_DOCUSIGN_ENDPOINT,
  UPDATE_SERVICE_FEE_PAYMENT_ENDPOINT,
  UPDATE_USER_DETAILS_ENDPOINT,
  UPLOAD_DOCUMENT_ENDPOINT,
  VALIDATE_MOBILE_EMAIL_ENDPOINT,
  SERVICE_REQUEST_CREATION_ENDPOINT_VERSION,
  SERVICE_REQUEST_ELIGIBILITY_ENDPOINT_VERSION_TWO,
  SERVICE_REQUEST_GET_CATALOGUE_END_VERSION_TWO,
  SERVICE_REQUEST_UPLOAD_FILES_VERSION_TWO,
  STATEMENT_SERVICE_CHARGE_DETAILS_ENDPOINT,
  SERVICE_FEE_STATEMENT_DETAILS_PDF_ENDPOINT,
  SERVICE_REQUEST_APPOINTMENT_SLOTS_VERSION_TWO,
  SERVICE_REQUEST_APPOINTMENT_SCHEDULE_VERSION_TWO,
  SERVICE_REQUEST_DETAILS_VERSION_TWO,
  SERVICE_REQUEST_CANCEL_VERSION_TWO,
  SERVICE_FEE_PAYMENT_SUMMARY_ENDPOINT,
  SERVICE_REQUEST_LIVE_TRACKING_VERSION_TWO,
  DARNAPOINT_DETAILS_ENDPOINT,
  SALES_JOURNEY_PROJECT_LIST_ENDPOINT,
  SALES_JOURNEY_ENDPOINT_GENERATOR,
  SERVICE_REQUEST_GET_CATALOGUE_AMC_LIST,
  SERVICE_REQUEST_CONFIG_V2_ENDPOINT,
  SERVICE_ENDPOINT_REOPEN_ENDPOINT,
  SPA_EMIRATES_ID_FRONT_ENPOINT,
  SPA_EMIRATES_ID_BACK_ENPOINT,
  SPA_PASSPORT_UPLOAD_ENPOINT,
  SPA_SET_DETAILS_ENPOINT,
  INVESTMENT_PORTFOLIO_PARAMS_ENDPOINT,
  INVESTMENT_PORTFOLIO_GRAPH_DATA_ENDPOINT,
  USER_PORTFOLIO_GRAPH_DATA_ENDPOINT,
  GET_FEATURE_FLAG_ENDPOINT,
  CONFIGURABLE_CONTENTS_ENDPOINT,
  GENERATE_SOA_NEW_ENDPOINT,
  DIGITAl_SALES_UNIT_LOCKING_ENPOINT,
  DIGITAl_SALES_UNIT_DETAILS_ENPOINT,
  DIGITAl_SALES_PAYMENT_PLANS_ENPOINT,
  DIGITAl_SALES_PAYMENT_DETAILS_ENPOINT,
  PROPERTY_SEARCH_FILTERS_ENPOINT,
  PROPERTY_SEARCH_ENPOINT,
  PROPERTY_SEARCH_SUGGESTIONS_ENPOINT,
  SALES_RECORDS_ENDPOINT,
  DS_CUSTOMER_DOCUMENT_ENDPOINT,
  AUTH_CHATBOT,
  ENCRYPTED_SYMMETRICK_KEY_ENPOINT,
  SPA_UAEPASS_INFO_ENPOINT,
  DOCUSIGN_V2_ENDPOINT,
  SPA_SET_DETAILS_V2_ENPOINT,
  MARKET_TREND_FILTERS_ENDPOINT,
  MARKET_TREND_ENDPOINT,
  USER_PORTFOLIO_GRAPH_ENDPOINT,
  PROFILE_UPDATE_GENERATE_OTP_ENDPOINT,
  PROFILE_UPDATE_RESEND_OTP_ENDPOINT,
  PROFILE_UPDATE_VALIDATE_OTP_ENDPOINT,
  EXTRACT_PASSPORT_DATA_ENDPOINT,
  EXTRACT_EMIRATESID_DATA_ENDPOINT,
  PREMIUM_PARKING_INVENTORY_ENDPOINT,
  PREMIUM_PARKING_ADDONS_ENDPOINT,
  PREMIUM_PARKING_QUOTE_AND_LINES_ITEM,
  PREMIUM_PARKING_LEAD_CREATE,
  PREMIUM_PARKING_OPPORTUNITY,
  PREMIUM_PARKING_SAVE_QUOTE,
  PREMIUM_PARKING_QUOTE_AGREEMENT,
  ORDER_SECRET_KEY,
  PREMIUM_PARKING_PRODUCTS_CONTENT,
  PREMIUM_PARKING_PRODUCTS_COST,
  PREMIUM_PARKING_ORDER_DETAILS,
  CREATE_PARKING_PAYMENT_ENDPOINT,
  CARD_ENCRYPTION_SECRET_KEY,
  PARKING_ORDERS_ENDPOINT,
  PARKING_PAYMENT_RECEIPT,
  PARKING_SET_PREM_PARKING_DETAILS_ENDPOINT,
  GET_PROPERTY_JOURNEY_DETAILS_ENPOINT,
  PROPERTY_JOURNEY_VIRTUAL_TOUR_ENPOINT,
  GET_APPOINTMENT_TIME_SLOTS_ENPOINT,
  CREATE_APPOINTMENT_ENPOINT,
  RESCHEDULE_APPOINTMENT_ENPOINT,
  GET_APPOINTMENT_DETAILS_ENPOINT,
  CANCEL_SALES_ORDER_ENDPOINT,
  HOME_ORIENTATION_FORM_OPTIONS_ENDPOINT,
  DIGITAL_SALES_SKIP_FASTTRACK_ENDPOINT,
  FASTTRACK_KYB_OPTIONS_ENDPOINT,
  FASTTRACK_SAVE_KYB_OPTIONS_ENDPOINT,
  FASTTRACK_GET_KYB_OPTIONS_ENDPOINT,
  DIGITAL_SALES_CREATE_FASTTRACK_ENDPOINT,
  DIGITAL_SALES_CREATE_CPRECORD_ENDPOINT,
  DIGITAL_SALES_GET_SALESMANAGERS_ENDPOINT,
  DIGITAL_SALES_UPDATE_SALESMANAGER_ENDPOINT,
  DIGITAL_SALES_UNIT_AVAILABILITY_ENDPOINT,
  DIGITAL_SALES_SHORTLISTED_UNITS_ENDPOINT,
  LEAN_CUSTOMER_ENDPOINT,
  BANK_DETAILS_ENDPOINT,
  LEAN_BANKS_ENDPOINT,
  DESTINATION_BANK_ENDPOINT,
  LEAN_PAYMENT_ENDPOINT,
  LEAN_PAYMENT_STATUS_ENDPOINT,
  LEAN_PAYMENT_COMPLETION_STATUS_ENDPOINT,
  LEASE_PAYMENT_TYPE,
  SERVICE_REQUEST_CASE_CREATION_V2_ENDPOINT,
  GET_DOCUMENT_LIST_ENDPOINT,
  DELETE_DOCUMENT_ENDPOINT,
  GLOBAL_NOTIFICATIONS_ENDPOINT,
  READ_GLOBAL_NOTIFICATIONS_ENDPOINT
} from "@/config/constants";
import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";
import { store } from "../store/configureStore";
import { getUrl } from "./urlService";
import { decryptData, decryptToken } from "./utils/encryption";
import { checkForSignzyFailure } from "@/fasttrackComponents/DetectSignzyFailure";
import {
  cardDetailsParser,
  paymentsDataParser,
  statementsDataParser,
  statusDetailsParser,
  summaryDataParser,
  parseFilterResponse,
  parseSummaryDataResponse,
  parseStatusDetailsResponse,
} from "./responseParser";
import { GetShortlistedPropertiesPayloadType, GetUnitAvailabilityPayloadType, UpdateOpportunityOwnerPayloadType } from "@/components/DigitalSales/DigitalSales.type";
import { CommonHeaders } from "@/types/header";
import { DeleteDocumentPayloadType, GetDocumentListPayloadType } from "@/components/FastrackNew/WealthDetails/WealthDetails.type";

const retryWrapper = (axios: any, options: any) => {
  return;
};

export const checkLeadEligibility = async (
  apiRequestBody: any,
  token?: any
): Promise<any> => {
  retryWrapper(axios, { retry_time: 1 });
  apiRequestBody.referenceId = store.getState().user?.account?.PersonEmail;
  const apiEndpoint = getUrl(LEAD_ELIGIBILITY_ENDPOINT);
  const options = {
    headers: getCommonHeaders(token),
  };
  try {
    const apiResponse = await axios.post(apiEndpoint, apiRequestBody, options);
    if ([401, 403].indexOf(apiResponse.status) !== -1) {
      return 403;
    }
    if ([200, 201].indexOf(apiResponse.data.statusCode) === -1) {
      return null;
    }
    return apiResponse.data;
  } catch (e: any) {
    if ([401, 403].indexOf(e.response?.status) !== -1) {
      return 403;
    }
    return null;
  }
};

export const createLead = async (
  apiRequestBody: any,
  token?: any
): Promise<any> => {
  retryWrapper(axios, { retry_time: 1 });
  apiRequestBody.referenceId = store.getState().user?.account?.PersonEmail;
  const apiEndpoint = getUrl(LEAD_CREATE_ENDPOINT);
  const options = {
    headers: getCommonHeaders(token),
  };
  try {
    const apiResponse = await axios.post(apiEndpoint, apiRequestBody, options);
    if ([401, 403].indexOf(apiResponse.status) !== -1) {
      return 403;
    }
    if ([200, 201].indexOf(apiResponse.status) === -1) {
      return null;
    }
    return apiResponse.data;
  } catch (e: any) {
    if ([401, 403].indexOf(e.response?.status) !== -1) {
      return 403;
    }
    return null;
  }
};

export const getSalesManagerList = async (
  apiRequestBody: any,
  token?: any
): Promise<any> => {
  retryWrapper(axios, { retry_time: 1 });
  apiRequestBody.referenceId = store.getState().user?.account?.PersonEmail;
  const apiEndpoint = getUrl(GET_SALES_MANAGER_LIST_ENDPOINT);
  const options = {
    headers: getCommonHeaders(token),
  };
  try {
    const apiResponse = await axios.post(apiEndpoint, apiRequestBody, options);
    if ([401, 403].indexOf(apiResponse.status) !== -1) {
      return 403;
    }
    if ([200, 201].indexOf(apiResponse.data.statusCode) === -1) {
      return null;
    }
    return apiResponse.data;
  } catch (e: any) {
    if ([401, 403].indexOf(e.response?.status) !== -1) {
      return 403;
    }
    return null;
  }
};

export const getUserDetails = async (
  mail: string | string[],
  token?: any
): Promise<any> => {
  retryWrapper(axios, { retry_time: 1 });
  const apiRequestBody = {
    email: mail,
    referenceId: mail,
    emiratesId: null,
    authentication: false,
  };
  try {
    const getUserDetailsEndpoint = getUrl(GET_USER_DETAILS_ENDPOINT);
    const options = {
      headers: getCommonHeaders(token),
    };
    const userDetails = await axios.post(
      getUserDetailsEndpoint,
      apiRequestBody,
      options
    );
    return apiResponseHandling(userDetails);
  } catch (e: any) {
    return apiErrorResponseHandling(e);
  }
};

export const getSalesOrderDetails = async (
  apiRequestBody: any,
  token?: any
): Promise<any> => {
  retryWrapper(axios, { retry_time: 1 });
  apiRequestBody.referenceId = store.getState().user?.account?.PersonEmail;
  try {
    const getUserDetailsEndpoint = getUrl(SALES_ORDER_DETAILS_ENDPOINT);
    const options = {
      headers: getCommonHeaders(token),
    };
    const salesOrderDetails = await axios.post(
      getUserDetailsEndpoint,
      apiRequestBody,
      options
    );
    return apiResponseHandling(salesOrderDetails);
  } catch (e: any) {
    return apiErrorResponseHandling(e);
  }
};

export const updateUserDetailsAPI = async (
  apiRequestBody: any,
  token?: any
): Promise<any> => {
  retryWrapper(axios, { retry_time: 1 });
  apiRequestBody.referenceId = store.getState().user?.account?.PersonEmail;
  const updateUserDetailsEndpoint = getUrl(UPDATE_USER_DETAILS_ENDPOINT);
  const options = {
    headers: getCommonHeaders(token),
  };
  try {
    const updateUserResponse = await axios.post(
      updateUserDetailsEndpoint,
      apiRequestBody,
      options
    );
    return apiResponseHandling(updateUserResponse);
  } catch (e: any) {
    return apiErrorResponseHandling(e);
  }
};

export const authenticateUserAPI = async (
  chatId: string,
  userEmail: string,
  authorization: string,
  token: string
) => {
  // Consolidate retry logic only if necessary
  retryWrapper(axios, { retry_time: 1 });

  const apiRequestBody = { email: userEmail, authorization, chatId };
  const authChatbotEndpoint = getUrl(AUTH_CHATBOT);
  const options = { headers: getCommonHeaders(token) };

  try {
    const { status, data } = await axios.post(authChatbotEndpoint, apiRequestBody, options);

    // Check for successful status codes and return structured response
    const success = status === 200 || status === 201;
    return { success, data: success ? data : null, errorMessage: success ? null : data?.statusMessage || "Unexpected response format" };

  } catch (error: any) {
    console.error("Chatbot Auth API Error:", error);

    // Handle error response with consistent structure
    const errorMessage = error.response?.data?.statusMessage || "Network error or server unavailable";
    const status = error.response?.status;
    return { success: false, errorMessage, status };
  }
};



export const setReminder = async (
  apiRequestBody: any,
  token?: any
): Promise<any> => {
  retryWrapper(axios, { retry_time: 1 });
  const setReminderEndpoint = getUrl(SET_REMINDER_ENDPOINT);
  const options = {
    headers: getCommonHeaders(token),
  };
  let setReminderResponse: any;
  try {
    setReminderResponse = await axios.post(
      setReminderEndpoint,
      apiRequestBody,
      options
    );
    return apiResponseHandling(setReminderResponse);
  } catch (e: any) {
    return apiErrorResponseHandling(e);
  }
};

export const getNotificationHistoryOld = async (
  mail?: any,
  token?: any
): Promise<any> => {
  retryWrapper(axios, { retry_time: 1 });
  const params = [
    {
      key: "EMAIL",
      value: mail, // will be replaced by user mail
    },
  ];
  const updateUserDetailsEndpoint = getUrl(
    NOTIFICATIONS_HISTORY_ENDPOINT,
    params
  );
  const options = {
    headers: getCommonHeaders(token),
  };
  let notificationsHistoryResponse: any;
  try {
    notificationsHistoryResponse = await axios.get(
      updateUserDetailsEndpoint,
      options
    );
    return notificationsHistoryResponse;
  } catch (e: any) {
    return apiErrorResponseHandling(e);
  }
};

export const readNotification = async (
  readNotificationRequest: any,
  token?: any
): Promise<any> => {
  retryWrapper(axios, { retry_time: 1 });
  const apiRequestBody = {
    id: readNotificationRequest.id,
    referenceId: store.getState().user?.account?.PersonEmail,
  };
  const updateUserDetailsEndpoint = getUrl(READ_NOTIFICATIONS_ENDPOINT);
  const options = {
    headers: getCommonHeaders(token),
  };
  let notificationsHistoryResponse: any;
  try {
    notificationsHistoryResponse = await axios.post(
      updateUserDetailsEndpoint,
      apiRequestBody,
      options
    );
    return apiResponseHandling(notificationsHistoryResponse);
  } catch (e: any) {
    return apiErrorResponseHandling(e);
  }
};

export const saveDeviceDetailsSet = async (
  apiRequestBody: any,
  token?: any
): Promise<any> => {
  retryWrapper(axios, { retry_time: 1 });
  const saveDeviceDetailsEndpoint = getUrl(SAVE_DEVICE_DETAILS_ENDPOINT);
  const options = {
    headers: getCommonHeaders(token),
  };
  let saveDeviceDetailsResponse: any;
  try {
    saveDeviceDetailsResponse = await axios.post(
      saveDeviceDetailsEndpoint,
      apiRequestBody,
      options
    );
    return apiResponseHandling(saveDeviceDetailsResponse);
  } catch (e: any) {
    return apiErrorResponseHandling(e);
  }
};

export const createHandoff = async (
  apiRequestBody: any
): Promise<any> => {
  retryWrapper(axios, { retry_time: 1 });
  const apiEndpoint = getUrl(CREATE_HANDOFF_ENDPOINT);
  const options = {
    headers: getCommonHeadersWithoutToken(),
  };
  try {
    const response = await axios.post(
      apiEndpoint,
      apiRequestBody,
      options
    );
    if ([401, 403].includes(response.status)) {
      return 403;
    }
    return response.data;
  } catch (e: any) {
    return apiErrorResponseHandling(e);
  }
};

export const getGlobalConfig = async (
  token?: any,
  isFasttrackTransform: boolean = false,
  enableReformedSourceRules: boolean = false
): Promise<any> => {
  retryWrapper(axios, { retry_time: 1 });
  let homeContentEndpoint = getUrl(GLOBAL_CONFIG_ENDPOINT);
  if (isFasttrackTransform) {
    homeContentEndpoint += '?isFasttrackTransform=true';
  }
  if(enableReformedSourceRules) {
    homeContentEndpoint += '&enableReformedSourceRules=true';
  }
  const options = {
    headers: getCommonHeaders(token),
  };
  const cityListUrl = getUrl(CITY_LIST_CONFIG);

  try {
    // const cityListResponse = await axios.get(cityListUrl);
    const homeContentResponse = await axios.get(homeContentEndpoint, options);
    if ([401, 403].indexOf(homeContentResponse.status) !== -1) {
      return 403;
    }
    if ([200, 201].indexOf(homeContentResponse.data.statusCode) === -1) {
      return null;
    }
    // const city = parseCityResponse(cityListResponse.data.data.countries);
    return { ...homeContentResponse.data.data, city: [] };
  } catch (e: any) {
    if ([401, 403].indexOf(e.response?.status) !== -1) {
      return 403;
    }
    return null;
  }
};
const parseCityResponse = (
  data: { country_name: string; city: string[] }[]
): Record<string, string[]> => {
  return data.reduce(
    (acc: Record<string, string[]>, { country_name, city }) => {
      acc[country_name] = city ?? [];
      return acc;
    },
    {}
  );
};

export const getHomeContent = async (
  customerId: string,
  token?: any
): Promise<any> => {
  retryWrapper(axios, { retry_time: 1 });
  const apiRequestBody = {
    customerId: customerId,
    referenceId: store.getState().user?.account?.PersonEmail,
  };
  const homeContentEndpoint = getUrl(HOME_ENDPOINT);
  const options = {
    headers: getCommonHeaders(token),
  };
  try {
    const homeContentResponse = await axios.post(
      homeContentEndpoint,
      apiRequestBody,
      options
    );
    if ([401, 403].indexOf(homeContentResponse.status) !== -1) {
      return 403;
    }
    if ([200, 201].indexOf(homeContentResponse.data.statusCode) === -1) {
      return null;
    }
    return homeContentResponse.data.data;
  } catch (e: any) {
    if ([401, 403].indexOf(e.response?.status) !== -1) {
      return 403;
    }
    return null;
  }
};

export const getPropertyJourney = async (
  apiRequestBody: any,
  token?: any
): Promise<any> => {
  apiRequestBody.referenceId = store.getState().user?.account?.PersonEmail;
  retryWrapper(axios, { retry_time: 1 });
  const propertyEndPoint = getUrl(PROPERTY_JOURNEY_ENDPOINT);
  const options = {
    headers: getCommonHeaders(token),
  };

  try {
    const propertyJourneyResponse = await axios.post(
      propertyEndPoint,
      apiRequestBody,
      options
    );
    if ([401, 403].indexOf(propertyJourneyResponse.status) !== -1) {
      return 403;
    }
    if ([200, 201].indexOf(propertyJourneyResponse.data.statusCode) === -1) {
      return null;
    }
    return propertyJourneyResponse.data;
  } catch (e: any) {
    if ([401, 403].indexOf(e.response?.status) !== -1) {
      return 403;
    }
    return null;
  }
};

export const getPropertyJourneys = async (
  apiRequestBody: any,
  token?: any
): Promise<any> => {
  retryWrapper(axios, { retry_time: 1 });
  apiRequestBody.referenceId = store.getState().user?.account?.PersonEmail;
  const propertyEndPoint = getUrl(PROPERTY_JOURNEYS_ENDPOINT);
  const options = {
    headers: getCommonHeaders(token),
  };

  try {
    const propertyJourneyResponse = await axios.post(
      propertyEndPoint,
      apiRequestBody,
      options
    );
    if ([401, 403].indexOf(propertyJourneyResponse.status) !== -1) {
      return 403;
    }
    if ([200, 201].indexOf(propertyJourneyResponse.data.statusCode) === -1) {
      return null;
    }
    return propertyJourneyResponse.data;
  } catch (e: any) {
    if ([401, 403].indexOf(e.response?.status) !== -1) {
      return 403;
    }
    return null;
  }
};
// service request related apis
export const getServiceRequestsEligibilty = async (
  apiRequestBody: any,
  token?: any
): Promise<any> => {
  retryWrapper(axios, { retry_time: 1 });
  apiRequestBody.referenceId = store.getState().user?.account?.PersonEmail;
  const serviceRequestSearchEndpoint = getUrl(
    SERVICE_REQUEST_ELIGIBILITY_ENDPOINT
  );
  const options = {
    headers: getCommonHeaders(token),
  };
  try {
    const serviceRequestsEligibiltyResponse = await axios.post(
      serviceRequestSearchEndpoint,
      apiRequestBody,
      options
    );
    if ([401, 403].indexOf(serviceRequestsEligibiltyResponse.status) !== -1) {
      return 403;
    }
    if (
      [200, 201].indexOf(serviceRequestsEligibiltyResponse.data.statusCode) ===
      -1
    ) {
      return null;
    }
    return serviceRequestsEligibiltyResponse?.data?.data;
  } catch (e: any) {
    if ([401, 403].indexOf(e.response?.status) !== -1) {
      return 403;
    }
    return Promise.reject(e);
  }
};

export const getServiceRequests = async (
  apiRequestBody: any,
  token?: any
): Promise<any> => {
  retryWrapper(axios, { retry_time: 1 });
  apiRequestBody.referenceId = store.getState().user?.account?.PersonEmail;
  const serviceRequestSearchEndpoint = getUrl(SERVICE_REQUEST_SEARCH_ENDPOINT);
  const options = {
    headers: getCommonHeaders(token),
  };
  try {
    const serviceRequestSearchResponse = await axios.post(
      serviceRequestSearchEndpoint,
      apiRequestBody,
      options
    );
    if ([401, 403].indexOf(serviceRequestSearchResponse.status) !== -1) {
      return 403;
    }
    if (
      [200, 201].indexOf(serviceRequestSearchResponse.data.statusCode) === -1
    ) {
      return null;
    }
    return serviceRequestSearchResponse?.data?.data;
  } catch (e: any) {
    if ([401, 403].indexOf(e.response?.status) !== -1) {
      return 403;
    }
    return null;
  }
};

export const createServiceRequest = async (
  apiRequestBody: any,
  token?: any
): Promise<any> => {
  retryWrapper(axios, { retry_time: 1 });
  apiRequestBody.referenceId = store.getState().user?.account?.PersonEmail;
  const serviceRequestCreationEndpoint = getUrl(
    SERVICE_REQUEST_CREATION_ENDPOINT
  );
  const options = {
    headers: getCommonHeaders(token),
  };
  try {
    const serviceRequestSearchResponse = await axios.post(
      serviceRequestCreationEndpoint,
      apiRequestBody,
      options
    );
    if ([401, 403].indexOf(serviceRequestSearchResponse.status) !== -1) {
      return 403;
    }
    if (
      [200, 201].indexOf(serviceRequestSearchResponse.data.statusCode) === -1
    ) {
      
      return {
        errorCode: serviceRequestSearchResponse.data.statusCode,
      };
    }
    return serviceRequestSearchResponse?.data?.data;
  } catch (e: any) {
    if ([401, 403].indexOf(e.response?.status) !== -1) {
      return 403;
    }
    if ([406].indexOf(e.response?.status) !== -1) {
      return {
        errorCode: 406,
      };
    }
    return null;
  }
};

export const createServiceRequestV2 = async (
  apiRequestBody: any,
  token?: any
): Promise<any> => {
  retryWrapper(axios, { retry_time: 1 });
  apiRequestBody.referenceId = store.getState().user?.account?.PersonEmail;
  const serviceRequestCreationEndpoint = getUrl(
    SERVICE_REQUEST_CASE_CREATION_V2_ENDPOINT
  );
  const options = {
    headers: getCommonHeaders(token),
  };
  try {
    const serviceRequestSearchResponse = await axios.post(
      serviceRequestCreationEndpoint,
      apiRequestBody,
      options
    );
    return serviceRequestSearchResponse?.data;
  } catch (e: any) {
    if ([401, 403].indexOf(e.response?.status) !== -1) {
      return {statusCode:403};
    }
    if ([406].indexOf(e.response?.status) !== -1) {
      return {
        statusCode: 406,
      };
    }
    return null;
  }
};
// service request - customer managment fee
export const getCustomerManagmentFee = async (
  apiRequestBody: any,
  token?: any
): Promise<any> => {
  retryWrapper(axios, { retry_time: 1 });
  apiRequestBody.referenceId = store.getState().user?.account?.PersonEmail;
  const customerManagmentFeeEndpoint = getUrl(CUSTOMER_MANAGMENT_FEE_ENDPOINT);
  const options = {
    headers: getCommonHeaders(token),
  };
  try {
    const customerManagmentFeeResponse = await axios.post(
      customerManagmentFeeEndpoint,
      apiRequestBody,
      options
    );
    if ([401, 403].indexOf(customerManagmentFeeResponse.status) !== -1) {
      return 403;
    }
    if (
      [200, 201].indexOf(customerManagmentFeeResponse.data.statusCode) === -1
    ) {
      return null;
    }
    return customerManagmentFeeResponse?.data?.data;
  } catch (e: any) {
    if ([401, 403].indexOf(e.response?.status) !== -1) {
      return 403;
    }
    return null;
  }
};

export const getCustomerManagmentFeeStatus = async (
  apiRequestBody: any,
  token?: any
): Promise<any> => {
  retryWrapper(axios, { retry_time: 1 });
  apiRequestBody.referenceId = store.getState().user?.account?.PersonEmail;
  const customerManagmentFeeStatusEndpoint = getUrl(
    CUSTOMER_MANAGMENT_FEE_STATUS_ENDPOINT
  );
  const options = {
    headers: getCommonHeaders(token),
  };
  try {
    const customerManagmentFeeStatusResponse = await axios.post(
      customerManagmentFeeStatusEndpoint,
      apiRequestBody,
      options
    );
    if ([401, 403].indexOf(customerManagmentFeeStatusResponse.status) !== -1) {
      return 403;
    }
    if (
      [200, 201].indexOf(customerManagmentFeeStatusResponse.data.statusCode) ===
      -1
    ) {
      return null;
    }
    return customerManagmentFeeStatusResponse?.data?.data;
  } catch (e: any) {
    if ([401, 403].indexOf(e.response?.status) !== -1) {
      return 403;
    }
    return null;
  }
};

// payment related apis
export const getfinancialStatements = async (
  apiRequestBody: any,
  token?: any
): Promise<any> => {
  retryWrapper(axios, { retry_time: 1 });
  apiRequestBody.referenceId = store.getState().user?.account?.PersonEmail;
  const financaialStatementsEndpoint = getUrl(FINANCIAL_STATEMENTS_ENDPOINT);
  const options = {
    headers: getCommonHeaders(token),
  };
  try {
    const financaialStatementsResponse = await axios.post(
      financaialStatementsEndpoint,
      apiRequestBody,
      options
    );
    if ([401, 403].indexOf(financaialStatementsResponse.status) !== -1) {
      return 403;
    }
    if (
      [200, 201].indexOf(financaialStatementsResponse.data.statusCode) === -1
    ) {
      return null;
    }
    return financaialStatementsResponse.data.data;
  } catch (e: any) {
    if ([401, 403].indexOf(e.response?.status) !== -1) {
      return 403;
    }
    return null;
  }
};

export const getReceiptByPaymentId = async (
  apiRequestBody: any,
  token?: any
): Promise<any> => {
  retryWrapper(axios, { retry_time: 1 });
  apiRequestBody.referenceId = store.getState().user?.account?.PersonEmail;
  const documentListByCustomerIdEndpoint = getUrl(PAYMENT_RECEIPT_ENDPOINT);
  const options = {
    headers: getCommonHeaders(token),
  };
  try {
    const documentListByCustomerIdResponse = await axios.post(
      documentListByCustomerIdEndpoint,
      apiRequestBody,
      options
    );
    if ([401, 403].indexOf(documentListByCustomerIdResponse.status) !== -1) {
      return 403;
    }
    if (
      [200, 201].indexOf(documentListByCustomerIdResponse.data.statusCode) ===
      -1
    ) {
      return null;
    }
    return documentListByCustomerIdResponse.data.data;
  } catch (e: any) {
    if ([401, 403].indexOf(e.response?.status) !== -1) {
      return 403;
    }
    return null;
  }
};

export const getLeanCustomer = async (
  requestBody: any,
  token?: string,
  options? : {payment_type? : string}
): Promise<any> => {
  retryWrapper(axios, { retry_time: 1 });

  const endpointUrl = getUrl(LEAN_CUSTOMER_ENDPOINT);
  const requestConfig = {
    headers: getCommonHeaders(token, options),
  };

  try {
    const response = await axios.post(endpointUrl, requestBody, requestConfig);

    if ([401, 403].includes(response.status)) {
      return 403;
    }

    return response.data;
  } catch (error: any) {
    if ([401, 403].includes(error.response?.status)) {
      return 403;
    }
    return null;
  }
};

export const getBankDetails = async (
  requestBody: any,
  token?: string
): Promise<any> => {
  retryWrapper(axios, { retry_time: 1 });

  const endpointUrl = getUrl(BANK_DETAILS_ENDPOINT);
  const requestConfig = {
    headers: getCommonHeaders(token),
  };

  try {
    const response = await axios.post(endpointUrl, requestBody, requestConfig);

    if ([401, 403].includes(response.status)) {
      return 403;
    }

    return response.data;
  } catch (error: any) {
    if ([401, 403].includes(error.response?.status)) {
      return 403;
    }
    return null;
  }
};

export const getLeanBanks = async (
  token?: string,
  emiratesId?: string,
  customerId?: string,
  options? : {payment_type? : string}
): Promise<any> => {
  retryWrapper(axios, { retry_time: 1 });

  const baseUrl = getUrl(LEAN_BANKS_ENDPOINT);
  const endpointUrl = emiratesId ? `${baseUrl}?customer_id=${customerId}&force_sync=true` : baseUrl;
  const requestConfig = {
    headers: getCommonHeaders(token, options),
  };

  try {
    const response = await axios.get(endpointUrl, requestConfig);

    if ([401, 403].includes(response.status)) {
      return 403;
    }

    return response.data;
  } catch (error: any) {
    if ([401, 403].includes(error.response?.status)) {
      return 403;
    }
    return null;
  }
};

export const createDestinationBank = async (
  requestBody: any,
  token?: string
): Promise<any> => {
  retryWrapper(axios, { retry_time: 1 });

  const endpointUrl = getUrl(DESTINATION_BANK_ENDPOINT);
  const requestConfig = {
    headers: getCommonHeaders(token),
  };

  try {
    const response = await axios.post(endpointUrl, requestBody, requestConfig);

    if ([401, 403].includes(response.status)) {
      return 403;
    }

    return response.data;
  } catch (error: any) {
    return { status: 403, data: error.response.data};
  }
};

export const createLeanPaymentIntent = async (
  requestBody: any,
  token?: string,
  options?: any
): Promise<any> => {
  retryWrapper(axios, { retry_time: 1 });

  const endpointUrl = getUrl(LEAN_PAYMENT_ENDPOINT);
  const requestConfig = {
    headers: getCommonHeaders(token, options),
  };

  try {
    const response = await axios.post(endpointUrl, requestBody, requestConfig);

    if ([401, 403].includes(response.status)) {
      return 403;
    }

    return response.data;
  } catch (error: any) {
    return { status: 403, data: error.response.data};
  }
};


export const updateLeanPaymentStatus = async (
  paymentStatusPayload: any,
  authToken?: string
): Promise<any> => {
  retryWrapper(axios, { retry_time: 1 });
  const paymentStatusEndpoint = getUrl(LEAN_PAYMENT_STATUS_ENDPOINT);
  const requestConfig = {
    headers: getCommonHeaders(authToken),
  };

  try {
    const response = await axios.post(
      paymentStatusEndpoint,
      paymentStatusPayload,
      requestConfig
    );

    console.log("Lean payment status response:", response);

    if ([401, 403].includes(response.status)) {
      return 403;
    }
    return response.data;
  } catch (error: any) {
    if ([401, 403].includes(error.response?.status)) {
      return 403;
    }
    return null;
  }
};

export const getLeanPaymentCompletedStatus = async (
  paymentStatusPayload: any,
  authToken?: string
): Promise<any> => {
  retryWrapper(axios, { retry_time: 1 });
  const paymentStatusEndpoint = getUrl(LEAN_PAYMENT_COMPLETION_STATUS_ENDPOINT);
  const requestConfig = {
    headers: getCommonHeaders(authToken),
  };

  try {
    const response = await axios.post(
      paymentStatusEndpoint,
      paymentStatusPayload,
      requestConfig
    );

    if ([401, 403].includes(response.status)) {
      return 403;
    }
    return response.data;
  } catch (error: any) {
    if ([401, 403].includes(error.response?.status)) {
      return 403;
    }
    return null;
  }
};

export const createPayment = async (
  apiRequestBody: any,
  token?: any
): Promise<any> => {
  retryWrapper(axios, { retry_time: 1 });
  apiRequestBody.referenceId = store.getState().user?.account?.PersonEmail;
  const createPaymentEndpoint = getUrl(CREATE_PAYMENT_ENDPOINT);
  const options = {
    headers: getCommonHeaders(token),
  };
  try {
    const createPaymentResponse = await axios.post(
      createPaymentEndpoint,
      apiRequestBody,
      options
    );
    if ([401, 403].indexOf(createPaymentResponse.status) !== -1) {
      return 403;
    }
    // if ([200, 201].indexOf(createPaymentResponse.data.statusCode) === -1) {
    //     return null
    // }
    return createPaymentResponse?.data?.data;
  } catch (e: any) {
    if ([401, 403].indexOf(e.response?.status) !== -1) {
      return 403;
    }
    return null;
  }
};
// document related apis
export const getDocumentsByCustomerId = async (
  apiRequestBody: any,
  token?: any
): Promise<any> => {
  retryWrapper(axios, { retry_time: 1 });
  apiRequestBody.referenceId = store.getState().user?.account?.PersonEmail;
  const documentListByCustomerIdEndpoint = getUrl(
    DOCUMENTS_BY_CUSTOMER_ID_ENDPOINT
  );
  const options = {
    headers: getCommonHeaders(token),
  };
  try {
    const documentListByCustomerIdResponse = await axios.post(
      documentListByCustomerIdEndpoint,
      apiRequestBody,
      options
    );
    if ([401, 403].indexOf(documentListByCustomerIdResponse.status) !== -1) {
      return 403;
    }
    if (
      [200, 201].indexOf(documentListByCustomerIdResponse.data.statusCode) ===
      -1
    ) {
      return null;
    }
    return documentListByCustomerIdResponse.data.data;
  } catch (e: any) {
    if ([401, 403].indexOf(e.response?.status) !== -1) {
      return 403;
    }
    return null;
  }
};
export const getDocumentsByDocumentId = async (
  apiRequestBody: any,
  token?: any
): Promise<any> => {
  retryWrapper(axios, { retry_time: 1 });
  apiRequestBody.referenceId = store.getState().user?.account?.PersonEmail;
  const documentListByCustomerIdEndpoint = getUrl(
    DOCUMENTS_BY_DOCUMENT_ID_ENDPOINT
  );
  const options = {
    headers: getCommonHeaders(token),
  };
  try {
    const documentListByCustomerIdResponse = await axios.post(
      documentListByCustomerIdEndpoint,
      apiRequestBody,
      options
    );
    if ([401, 403].indexOf(documentListByCustomerIdResponse.status) !== -1) {
      return 403;
    }
    if (
      [200, 201].indexOf(documentListByCustomerIdResponse.data.statusCode) ===
      -1
    ) {
      return null;
    }
    return documentListByCustomerIdResponse.data.data;
  } catch (e: any) {
    if ([401, 403].indexOf(e.response?.status) !== -1) {
      return 403;
    }
    return null;
  }
};
export const getDocusignUrlAPI = async (
  apiRequestBody: any,
  token?: any
): Promise<any> => {
  retryWrapper(axios, { retry_time: 1 });
  apiRequestBody.referenceId = store.getState().user?.account?.PersonEmail;
  const docuSIgnUrlFetchEndpoint = getUrl(DOCUSIGN_ENDPOINT);
  const options = {
    headers: getCommonHeaders(token),
  };
  try {
    const body = apiRequestBody;
    const docuSignResponse = await axios.post(
      docuSIgnUrlFetchEndpoint,
      body,
      options
    );
    if ([401, 403].indexOf(docuSignResponse.status) !== -1) {
      return 403;
    }
    if ([400].indexOf(docuSignResponse.status) !== -1) {
      return 400;
    }
    if ([200, 201].indexOf(docuSignResponse.data.statusCode) === -1) {
      return null;
    }
    return docuSignResponse;
  } catch (e: any) {
    if ([401, 403].indexOf(e.response?.status) !== -1) {
      return 403;
    }
    if ([400].indexOf(e.response?.status) !== -1) {
      return 400;
    }
    return null;
  }
};

export const uploadDocumentAPI = async (
  apiRequestBody: any,
  token?: any
): Promise<any> => {
  retryWrapper(axios, { retry_time: 1 });
  apiRequestBody.referenceId = store.getState().user?.account?.PersonEmail;
  const uploadDocumentEndpoint = getUrl(UPLOAD_DOCUMENT_ENDPOINT);

  const options: any = {
    headers: getCommonHeaders(token),
  };
  try {
    const uploadDocumentEndpointResponse = await axios.post(
      uploadDocumentEndpoint,
      apiRequestBody,
      options
    );
    if ([401, 403].indexOf(uploadDocumentEndpointResponse.status) !== -1) {
      return 403;
    }
    if (
      [200, 201].indexOf(uploadDocumentEndpointResponse.data.statusCode) === -1
    ) {
      return null;
    }
    return uploadDocumentEndpointResponse;
  } catch (e: any) {
    if ([401, 403].indexOf(e.response?.status) !== -1) {
      return 403;
    }
    return null;
  }
};

// global search
export const getSearchResultsAPI = async (
  apiRequestBody: any,
  token?: any
): Promise<any> => {
  ////////////////
  retryWrapper(axios, { retry_time: 1 });
  apiRequestBody.referenceId = store.getState().user?.account?.PersonEmail;
  const globalSearchEndpoint = getUrl(GLOBAL_SEARCH_ENDPOINT);
  const options = {
    headers: getCommonHeaders(token),
  };
  try {
    const searchResultsResponse = await axios.post(
      globalSearchEndpoint,
      apiRequestBody,
      options
    );
    if ([401, 403].indexOf(searchResultsResponse.status) !== -1) {
      return 403;
    }
    if ([200, 201].indexOf(searchResultsResponse.data.statusCode) === -1) {
      return null;
    }
    return searchResultsResponse;
  } catch (e: any) {
    if ([401, 403].indexOf(e.response?.status) !== -1) {
      return 403;
    }
    return null;
  }
};

//Fasttrack services

export const leadConvert = async (
  apiRequestBody: any,
  token?: any
): Promise<any> => {
  retryWrapper(axios, { retry_time: 1 });
  apiRequestBody.referenceId = store.getState().user?.account?.PersonEmail;
  const apiEndpoint = getUrl(LEAD_CONVERT_ENDPOINT);
  const options = {
    headers: getCommonHeaders(token),
  };
  try {
    const apiResponse = await axios.post(apiEndpoint, apiRequestBody, options);
    if ([401, 403].indexOf(apiResponse.status) !== -1) {
      return 403;
    }
    if ([200, 201].indexOf(apiResponse.data.statusCode) === -1) {
      return null;
    }
    return apiResponse.data.data;
  } catch (e: any) {
    if ([401, 403].indexOf(e.response?.status) !== -1) {
      return 403;
    }
    return null;
  }
};

export const leadVerify = async (
  apiRequestBody: any,
  token?: any
): Promise<any> => {
  retryWrapper(axios, { retry_time: 1 });
  apiRequestBody.referenceId = store.getState().user?.account?.PersonEmail;
  const apiEndpoint = getUrl(LEAD_VERIFY_ENDPOINT);
  const options = {
    headers: getCommonHeaders(token),
  };
  try {
    const apiResponse = await axios.post(apiEndpoint, apiRequestBody, options);
    if ([401, 403].indexOf(apiResponse.status) !== -1) {
      return 403;
    }
    if ([200, 201].indexOf(apiResponse.data.statusCode) === -1) {
      return null;
    }
    return apiResponse;
  } catch (e: any) {
    if ([401, 403].indexOf(e.response?.status) !== -1) {
      return 403;
    }
    return null;
  }
};

export const opportunityUpdate = async (
  apiRequestBody: any,
  token?: any
): Promise<any> => {
  retryWrapper(axios, { retry_time: 1 });
  apiRequestBody.referenceId = store.getState().user?.account?.PersonEmail;
  const apiEndpoint = getUrl(OPPORTUNITY_UPDATE_ENDPOINT);
  const options = {
    headers: getCommonHeaders(token),
  };
  try {
    const apiResponse = await axios.post(apiEndpoint, apiRequestBody, options);
    if ([401, 403].indexOf(apiResponse.status) !== -1) {
      return 403;
    }
    if ([200, 201].indexOf(apiResponse.data.statusCode) === -1) {
      return null;
    }
    return apiResponse;
  } catch (e: any) {
    if ([401, 403].indexOf(e.response?.status) !== -1) {
      return 403;
    }
    return null;
  }
};

export const opportunityVerify = async (
  apiRequestBody: any,
  token?: any
): Promise<any> => {
  retryWrapper(axios, { retry_time: 1 });
  const apiEndpoint = getUrl(OPPORTUNITY_VERIFY_ENDPOINT);
  const options = {
    headers: getCommonHeaders(token),
  };
  try {
    const apiResponse = await axios.post(apiEndpoint, apiRequestBody, options);
    if ([401, 403].indexOf(apiResponse.status) !== -1) {
      return 403;
    }
    if ([200, 201].indexOf(apiResponse.data.statusCode) === -1) {
      return null;
    }
    return apiResponse;
  } catch (e: any) {
    if ([401, 403].indexOf(e.response?.status) !== -1) {
      return 403;
    }
    return null;
  }
};
export const accountUpdate = async (
  apiRequestBody: any,
  token?: any
): Promise<any> => {
  retryWrapper(axios, { retry_time: 1 });
  apiRequestBody.referenceId = store.getState().user?.account?.PersonEmail;
  const apiEndpoint = getUrl(ACCOUNT_UPDATE_ENDPOINT);
  const options = {
    headers: getCommonHeaders(token),
  };
  try {
    const apiResponse = await axios.post(apiEndpoint, apiRequestBody, options);
    if ([401, 403].indexOf(apiResponse.status) !== -1) {
      return 403;
    }
    if ([200, 201].indexOf(apiResponse.data.statusCode) === -1) {
      return {
        errorMessage: apiResponse.data.statusMessage,
      };
    }
    return apiResponse;
  } catch (e: any) {
    if ([401, 403].indexOf(e.response?.status) !== -1) {
      return 403;
    }
    return null;
  }
};
export const getAppointmentAvailableDates = async (
  apiRequestBody: any,
  token?: any
): Promise<any> => {
  retryWrapper(axios, { retry_time: 1 });
  apiRequestBody.referenceId = store.getState().user?.account?.PersonEmail;
  try {
    const apiEndpoint = getUrl(GET_APPOINTMENT_AVAILABLE_DATES_ENDPOINT);
    const options = {
      headers: getCommonHeaders(token),
    };
    const apiResponse = await axios.post(apiEndpoint, apiRequestBody, options);
    return apiResponseHandling(apiResponse);
  } catch (e: any) {
    return apiErrorResponseHandling(e);
  }
};
export const getAppointmentAvailableSlots = async (
  apiRequestBody: any,
  token?: any
): Promise<any> => {
  retryWrapper(axios, { retry_time: 1 });
  apiRequestBody.referenceId = store.getState().user?.account?.PersonEmail;
  try {
    const apiEndpoint = getUrl(GET_APPOINTMENT_AVAILABLE_SLOTS_ENDPOINT);
    const options = {
      headers: getCommonHeaders(token),
    };
    const apiResponse = await axios.post(apiEndpoint, apiRequestBody, options);
    return apiResponseHandling(apiResponse);
  } catch (e: any) {
    return apiErrorResponseHandling(e);
  }
};

export const createUpdateAppointment = async (
  apiRequestBody: any,
  token?: any
): Promise<any> => {
  retryWrapper(axios, { retry_time: 1 });
  apiRequestBody.referenceId = store.getState().user?.account?.PersonEmail;
  try {
    const apiEndpoint = getUrl(CREATE_UPDATE_APPOINTMENT_ENDPOINT);
    const options = {
      headers: getCommonHeaders(token),
    };
    const apiResponse = await axios.post(apiEndpoint, apiRequestBody, options);
    return apiResponseHandling(apiResponse);
  } catch (e: any) {
    return apiErrorResponseHandling(e);
  }
};

export const cancelAppointment = async (
  apiRequestBody: any,
  token?: any
): Promise<any> => {
  retryWrapper(axios, { retry_time: 1 });
  apiRequestBody.referenceId = store.getState().user?.account?.PersonEmail;
  try {
    const apiEndpoint = getUrl(CANCEL_APPOINTMENT_ENDPOINT);
    const options = {
      headers: getCommonHeaders(token),
    };
    const apiResponse = await axios.post(apiEndpoint, apiRequestBody, options);
    return apiResponseHandling(apiResponse);
  } catch (e: any) {
    return apiErrorResponseHandling(e);
  }
};

export const generateSOAApi = async (
  apiRequestBody: any,
  token?: any
): Promise<any> => {
  retryWrapper(axios, { retry_time: 1 });
  apiRequestBody.referenceId = store.getState().user?.account?.PersonEmail;
  try {
    const apiEndpoint = getUrl(GENERATE_SOA_NEW_ENDPOINT);
    const options = {
      headers: getCommonHeaders(token),
    };
    const apiResponse = await axios.post(apiEndpoint, apiRequestBody, options);
    return apiResponseHandling(apiResponse);
  } catch (e: any) {
    return apiErrorResponseHandling(e);
  }
};

export const getProjectDetails = async (
  apiRequestBody: any,
  token?: any
): Promise<any> => {
  retryWrapper(axios, { retry_time: 1 });
  apiRequestBody.referenceId = store.getState().user?.account?.PersonEmail;
  try {
    const apiEndpoint = getUrl(PROJECT_DETAILS_ENDPOINT);
    const options = {
      headers: getCommonHeaders(token),
    };
    const apiResponse = await axios.post(apiEndpoint, apiRequestBody, options);
    return apiResponseHandling(apiResponse);
  } catch (e: any) {
    return apiErrorResponseHandling(e);
  }
};

export const getFaqDetails = async (token?: any): Promise<any> => {
  retryWrapper(axios, { retry_time: 1 });

  try {
    const apiEndpoint: any = getUrl(FAQ_ENDPOINT);
    const options = {
      headers: getCommonHeaders(token),
    };
    const apiResponse = await axios.get(apiEndpoint, options);
    if ([401, 403].indexOf(apiResponse.status) !== -1) {
      return 403;
    }
    return apiResponse;
  } catch (e: any) {
    return apiErrorResponseHandling(e);
  }
};

export const getNews = async (token?: any): Promise<any> => {
  retryWrapper(axios, { retry_time: 1 });

  try {
    const apiEndpoint: any = getUrl(NEWS_EVENTS_ENDPOINT);
    const options = {
      headers: getCommonHeaders(token),
    };
    const apiResponse = await axios.get(apiEndpoint, options);
    if ([401, 403].indexOf(apiResponse.status) !== -1) {
      return 403;
    }
    return apiResponse;
  } catch (e: any) {
    return apiErrorResponseHandling(e);
  }
};
export const getNewsDetails = async (
  apiRequestBody: any,
  token?: any
): Promise<any> => {
  retryWrapper(axios, { retry_time: 1 });

  try {
    const apiEndpoint: any = getUrl(NEWS_DETAILS_ENDPOINT);
    const options = {
      headers: getCommonHeaders(token),
    };
    const apiResponse = await axios.post(apiEndpoint, apiRequestBody, options);
    if ([401, 403].indexOf(apiResponse.status) !== -1) {
      return 403;
    }
    return apiResponse;
  } catch (e: any) {
    return apiErrorResponseHandling(e);
  }
};
export const getNewsLisiting = async (
  apiRequestBody: any,
  token?: any
): Promise<any> => {
  retryWrapper(axios, { retry_time: 1 });

  try {
    const apiEndpoint: any = getUrl(NEWS_LISTING_ENDPOINT);
    const options = {
      headers: getCommonHeaders(token),
    };
    const apiResponse = await axios.post(apiEndpoint, apiRequestBody, options);
    if ([401, 403].indexOf(apiResponse.status) !== -1) {
      return 403;
    }
    return apiResponse;
  } catch (e: any) {
    return apiErrorResponseHandling(e);
  }
};
export const getCommunityDetails = async (
  apiRequestBody: any,
  token?: any
): Promise<any> => {
  retryWrapper(axios, { retry_time: 1 });
  //apiRequestBody.referenceId = store.getState().user?.account?.PersonEmail
  try {
    const apiEndpoint: any = getUrl(COMMUNITY_UPDATE_ENDPOINT);
    const options = {
      headers: getCommonHeaders(token),
    };
    const apiResponse = await axios.post(apiEndpoint, apiRequestBody, options);
    if ([401, 403].indexOf(apiResponse.status) !== -1) {
      return 403;
    }
    return apiResponse;
  } catch (e: any) {
    return apiErrorResponseHandling(e);
  }
};

export const getCommunityHighlights = async (
  apiRequestBody: any,
  token?: any
): Promise<any> => {
  retryWrapper(axios, { retry_time: 1 });
  //apiRequestBody.referenceId = store.getState().user?.account?.PersonEmail
  try {
    const apiEndpoint: any = getUrl(COMMUNITY_HIGHLIGHTS_ENDPOINT);
    const options = {
      headers: getCommonHeaders(token),
    };
    const apiResponse = await axios.post(apiEndpoint, apiRequestBody, options);
    if ([401, 403].indexOf(apiResponse.status) !== -1) {
      return 403;
    }
    return apiResponse;
  } catch (e: any) {
    return apiErrorResponseHandling(e);
  }
};

export const getConstructionDetails = async (
  apiRequestBody: any,
  token?: any
): Promise<any> => {
  retryWrapper(axios, { retry_time: 1 });
  //apiRequestBody.referenceId = store.getState().user?.account?.PersonEmail
  try {
    const apiEndpoint: any = getUrl(CONSTRUCTION_UPDATE_ENDPOINT);
    const options = {
      headers: getCommonHeaders(token),
    };
    const apiResponse = await axios.post(apiEndpoint, apiRequestBody, options);
    if ([401, 403].indexOf(apiResponse.status) !== -1) {
      return 403;
    }
    return apiResponse;
  } catch (e: any) {
    return apiErrorResponseHandling(e);
  }
};
export const updateDocusign = async (
  apiRequestBody: any,
  token?: any
): Promise<any> => {
  retryWrapper(axios, { retry_time: 1 });
  apiRequestBody.referenceId = store.getState().user?.account?.PersonEmail;
  try {
    const apiEndpoint = getUrl(UPDATE_DOCUSIGN_ENDPOINT);
    const options = {
      headers: getCommonHeaders(token),
    };
    const apiResponse = await axios.post(apiEndpoint, apiRequestBody, options);
    return apiResponseHandling(apiResponse);
  } catch (e: any) {
    return apiErrorResponseHandling(e);
  }
};

export const validateMobileEmail = async (
  apiRequestBody: any,
  token?: any
): Promise<any> => {
  retryWrapper(axios, { retry_time: 1 });
  try {
    const apiEndpoint = getUrl(VALIDATE_MOBILE_EMAIL_ENDPOINT);
    const options = {
      headers: getCommonHeaders(token),
    };
    const apiResponse = await axios.post(apiEndpoint, apiRequestBody, options);
    return apiResponseHandling(apiResponse);
  } catch (e: any) {
    return apiErrorResponseHandling(e);
  }
};
export const generatePerformaInvoice = async (
  apiRequestBody: any,
  token?: any
): Promise<any> => {
  retryWrapper(axios, { retry_time: 1 });
  apiRequestBody.referenceId = store.getState().user?.account?.PersonEmail;
  try {
    const apiEndpoint = getUrl(PERFORMA_INVOICE_ENDPOINT);
    const options = {
      headers: getCommonHeaders(token),
    };
    const apiResponse = await axios.post(apiEndpoint, apiRequestBody, options);
    return apiResponseHandling(apiResponse);
  } catch (e: any) {
    return apiErrorResponseHandling(e);
  }
};
export const getNotificationHistory = async (
  apiRequestBody: any,
  token?: any
): Promise<any> => {
  retryWrapper(axios, { retry_time: 1 });
  apiRequestBody.referenceId = store.getState().user?.account?.PersonEmail;
  try {
    const apiEndpoint = getUrl(NOTIFICATIONS_HISTORY_ENDPOINT);
    const options = {
      headers: getCommonHeaders(token),
    };
    const apiResponse = await axios.post(apiEndpoint, apiRequestBody, options);
    if ([401, 403].indexOf(apiResponse.status) !== -1) {
      return 403;
    }
    if (!apiResponse.data) {
      return {
        errorMessage: "Problem occurred while fetching notifications",
      };
    }
    return apiResponse;
  } catch (e: any) {
    return apiErrorResponseHandling(e);
  }
};

export const getGlobalNotifications = async (
  apiRequestBody: any,
  token?: any
): Promise<any> => {
  retryWrapper(axios, { retry_time: 1 });
  apiRequestBody.referenceId = store.getState().user?.account?.PersonEmail;
  try {
    const apiEndpoint = getUrl(GLOBAL_NOTIFICATIONS_ENDPOINT);
    const options = {
      headers: getCommonHeaders(token),
    };
    const apiResponse = await axios.post(apiEndpoint, apiRequestBody, options);
    if ([401, 403].indexOf(apiResponse.status) !== -1) {
      return 403;
    }
    return apiResponse;
  } catch (e: any) {
    return apiErrorResponseHandling(e);
  }
};

export const readGlobalNotification = async (
  notificationId: string,
  token?: string
): Promise<any> => {
  retryWrapper(axios, { retry_time: 1 });
  const userEmail = store.getState().user?.account?.PersonEmail;
  const customerId = store.getState().user?.account?.Id;
  const apiRequestBody = {
    notificationId: notificationId ? Number(notificationId) : "",
    userId: userEmail,
    referenceId: userEmail,
    customerId
  };
  const updateUserDetailsEndpoint = getUrl(READ_GLOBAL_NOTIFICATIONS_ENDPOINT);
  const options = {
    headers: getCommonHeaders(token),
  };
  let notificationsHistoryResponse: any;
  try {
    notificationsHistoryResponse = await axios.post(
      updateUserDetailsEndpoint,
      apiRequestBody,
      options
    );
    return apiResponseHandling(notificationsHistoryResponse);
  } catch (e: any) {
    return apiErrorResponseHandling(e);
  }
};

export const getProjectImagesSitecore = async (
  apiRequestBody: any
): Promise<any> => {
  retryWrapper(axios, { retry_time: 1 });

  try {
    const apiEndpoint: any = getUrl(PROJECT_IMAGES_SEARCH_ENDPOINT);
    const options = {
      headers: getCommonHeadersWithoutToken(),
    };
    const apiResponse = await axios.post(apiEndpoint, apiRequestBody, options);
    return apiResponse;
  } catch (e: any) {
    return apiErrorResponseHandling(e);
  }
};

const apiResponseHandling = async (apiResponse: any): Promise<any> => {
  if ([401, 403].indexOf(apiResponse.status) !== -1) {
    return 403;
  }
  if ([200, 201, "200", "201"].indexOf(apiResponse.data.statusCode) === -1) {
    return {
      errorMessage: apiResponse.data.statusMessage,
    };
  }
  return apiResponse;
};

const apiErrorResponseHandling = async (apiError: any): Promise<any> => {
  if ([401, 403].indexOf(apiError.response?.status) !== -1) {
    return 403;
  }
  return null;
};
const signzyServiceErrorHandler = (error: AxiosError) => {
  if ([401, 403].indexOf(error.response!.status) !== -1) {
    return 403;
  }
  if ([422].indexOf(error.response!.status) !== -1) {
    return error;
  }
  const { isSignzyFail } = checkForSignzyFailure(error.response?.data as any);
  if (!isSignzyFail) return;
  throw error;
};

export const getCommonHeaders = (
  token?: string,
  options?: { payment_type?: string }
): CommonHeaders => {
  const headers: CommonHeaders = {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods": "POST, GET, OPTIONS, DELETE, PATCH",
    Authorization: `Bearer ${decryptToken(token) ? decryptToken(token) : store.getState().user.token
      }`,
  };

  if (options?.payment_type === LEASE_PAYMENT_TYPE) {
    headers["payment-type"] = LEASE_PAYMENT_TYPE;
  }

  return headers;
};
const getCommonHeadersWithoutToken = (token?: any): any => {
  const commonHeadersWithoutToken = getCommonHeaders();
  delete commonHeadersWithoutToken.Authorization;
  return commonHeadersWithoutToken;
};

const SIGNZY_BASE_URL = process.env.NEXT_PUBLIC_DOCUMENT_HOST_NAME;
const PATH = {
  ACCESS_TOKEN: "/auth/access-token",
  FILE_UPLOAD: "kyc/upload",
  PASSPORT_DETECTION: "kyc/passport-dection",
  PASSPORT_EXTRACTION: "kyc/passport-extraction",
  FACE_MATCHES_DETECTIOn: "kyc/facematch-detection",
  FORGERY_CHECK: "kyc/forgery-check-validation",
  ID_INTEL: "kyc/id-intelligence",
  EID_VERIFICATION: "kyc/emiratesid-verify",
  VIDEO_FRAME: "kyc/video-frame",
  CHECK_LIVENESS: "kyc/checkliveness",
  SPA_CHECK_LIVENESS: "digital-spa/check-liveness",
  CHECK_IMAGE_QUALITY: "kyc/checkimagequality",
  PASSPORT_UPLOAD: "kyc/uploadpassport",
  EMIRATES_ID_FRONT: "kyc/uploademiratesidfrontpage",
  EMIRATES_ID_BACK: "kyc/uploademiratesId",
  SCAN_EMIRATES_ID_FRONT: "kyc/scanemiratesidfrontpage",
  SCAN_EMIRATES_ID_BACK: "kyc/verifyemiratesId",
  GET_FASTTRACK: "kyc/getFastrackDetails",
  SET_FASTTRACK: "kyc/setFastrackDetails",
  SET_UAE_RESIDENT: "kyc/setuaeresident",
  SERVICE_REQUEST_UPLOAD: "fileUpload/uploadToAzure",
};

const getHeaderForDocUpload = (token?: any) => {
  return {
    "Content-Type": "multipart/form-data",
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods": "POST, GET, OPTIONS, DELETE",
    Authorization: `Bearer ${decryptToken(token) ? decryptToken(token) : store.getState().user.token
      }`,
  };
};

///
export const getKYCToken = async (token: any, payload: any): Promise<any> => {
  retryWrapper(axios, { retry_time: 1 });
  try {
    const apiEndpoint: any = SIGNZY_BASE_URL + PATH.ACCESS_TOKEN;
    const options = {
      headers: getCommonHeaders(token),
    };
    const apiResponse = await axios.post(apiEndpoint, payload, options);
    if ([401, 403].indexOf(apiResponse.status) !== -1) {
      return 403;
    }
    return apiResponse;
  } catch (e: any) {
    return signzyServiceErrorHandler(e);
  }
};

export const fastTrackUploadDocuments = async (
  apiRequestBody: any,
  token?: any
): Promise<any> => {
  retryWrapper(axios, { retry_time: 1 });
  apiRequestBody.referenceId = store.getState().user?.account?.PersonEmail;
  const uploadDocumentEndpoint = getUrl(UPLOAD_DOCUMENT_ENDPOINT);

  const options: any = {
    headers: getCommonHeaders(token),
  };
  try {
    const uploadDocumentEndpointResponse = await axios.post(
      uploadDocumentEndpoint,
      apiRequestBody,
      options
    );
    if ([401, 403].indexOf(uploadDocumentEndpointResponse.status) !== -1) {
      `return 403`;
    }
    if (
      [200, 201].indexOf(uploadDocumentEndpointResponse.data.statusCode) === -1
    ) {
      return uploadDocumentEndpointResponse.data;
    }
    return uploadDocumentEndpointResponse;
  } catch (e: any) {
    signzyServiceErrorHandler(e);
    // return null;
  }
};

export const checkImageQuality = async (payload: any, token: string) => {
  try {
    const apiEndpoint: any = SIGNZY_BASE_URL + PATH.CHECK_IMAGE_QUALITY;
    const options = {
      headers: getHeaderForDocUpload(token),
    };

    const apiResponse = await axios.post(apiEndpoint, payload, options);
    if ([401, 403].indexOf(apiResponse.status) !== -1) {
      return 403;
    }
    if ([200, 201].indexOf(apiResponse.data.statusCode) === -1) {
      return apiResponse.data;
    }
    return apiResponse;
  } catch (e: any) {
    return signzyServiceErrorHandler(e);
  }
};

export const uploadPassport = async (payload: any, token: string) => {
  try {
    const apiEndpoint: any = SIGNZY_BASE_URL + PATH.PASSPORT_UPLOAD;
    const options = {
      headers: getHeaderForDocUpload(token),
    };

    const apiResponse = await axios.post(apiEndpoint, payload, options);
    if ([401, 403].indexOf(apiResponse.status) !== -1) {
      return 403;
    }
    if ([200, 201].indexOf(apiResponse.data.statusCode) === -1) {
      return apiResponse.data;
    }
    return apiResponse;
  } catch (e: any) {
    return signzyServiceErrorHandler(e);
  }
};

export const uploadEmiratesIdFront = async (payload: any, token: string) => {
  try {
    const apiEndpoint: any = SIGNZY_BASE_URL + PATH.EMIRATES_ID_FRONT;
    const options = {
      headers: getHeaderForDocUpload(token),
    };

    const apiResponse = await axios.post(apiEndpoint, payload, options);
    if ([401, 403].indexOf(apiResponse.status) !== -1) {
      return 403;
    }
    if ([200, 201].indexOf(apiResponse.data.statusCode) === -1) {
      return apiResponse.data;
    }
    return apiResponse;
  } catch (e: any) {
    return signzyServiceErrorHandler(e);
  }
};

export const uploadEmiratesIdBack = async (payload: any, token: string) => {
  try {
    const apiEndpoint: any = SIGNZY_BASE_URL + PATH.EMIRATES_ID_BACK;
    const options = {
      headers: getHeaderForDocUpload(token),
    };

    const apiResponse = await axios.post(apiEndpoint, payload, options);
    if ([401, 403].indexOf(apiResponse.status) !== -1) {
      return 403;
    }
    if ([200, 201].indexOf(apiResponse.data.statusCode) === -1) {
      return apiResponse.data;
    }
    return apiResponse;
  } catch (e: any) {
    return signzyServiceErrorHandler(e);
  }
};

export const checkLiveliness = async (payload: any, token: string) => {
  try {
    const apiEndpoint: any = SIGNZY_BASE_URL + PATH.CHECK_LIVENESS;
    const options = {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "POST, GET, OPTIONS, DELETE",
        "Content-Type": "application/json",
        Authorization: `Bearer ${decryptToken(token)
          ? decryptToken(token)
          : store.getState().user.token
          }`,
      },
    };

    const apiResponse = await axios.post(
      apiEndpoint,
      JSON.stringify(payload),
      options
    );
    if ([401, 403].indexOf(apiResponse.status) !== -1) {
      return 403;
    }
    if ([200, 201].indexOf(apiResponse.data.statusCode) === -1) {
      return apiResponse.data;
    }
    return apiResponse;
  } catch (e: any) {
    return signzyServiceErrorHandler(e);
  }
};
///

export const getFastrackDetails = async (payload: any, token: string) => {
  const apiEndpoint: any = SIGNZY_BASE_URL + PATH.GET_FASTTRACK;
  const options = {
    headers: getCommonHeaders(token),
  };
  try {
    const apiResponse = await axios.post(apiEndpoint, payload, options);
    if ([401, 403].indexOf(apiResponse.status) !== -1) {
      return 403;
    }
    if ([200, 201].indexOf(apiResponse.data.statusCode) === -1) {
      return null;
    }
    return apiResponse;
  } catch (e: any) {
    if ([401, 403].indexOf(e.response?.status) !== -1) {
      return 403;
    }
    return null;
  }
};

export const setFastrackDetails = async (payload: any, token: string) => {
  const apiEndpoint: any = SIGNZY_BASE_URL + PATH.SET_FASTTRACK;
  const options = {
    headers: getCommonHeaders(token),
  };
  try {
    const apiResponse = await axios.post(apiEndpoint, payload, options);
    if ([401, 403].indexOf(apiResponse.status) !== -1) {
      return 403;
    }
    if ([200, 201].indexOf(apiResponse.data.statusCode) === -1) {
      return apiResponse;
    }
    return apiResponse;
  } catch (e: any) {
    if ([401, 403].indexOf(e.response?.status) !== -1) {
      return 403;
    }
    return null;
  }
};

export const setUaeResident = async (payload: any, token: string) => {
  const apiEndpoint: any = SIGNZY_BASE_URL + PATH.SET_UAE_RESIDENT;
  const options = {
    headers: getCommonHeaders(token),
  };
  try {
    const apiResponse = await axios.post(apiEndpoint, payload, options);
    if ([401, 403].indexOf(apiResponse.status) !== -1) {
      return 403;
    }
    if ([200, 201].indexOf(apiResponse.data.statusCode) === -1) {
      return apiResponse.data;
    }
    return apiResponse;
  } catch (e: any) {
    if ([401, 403].indexOf(e.response?.status) !== -1) {
      return 403;
    }
    return null;
  }
};

export const getNoPropertiesData = async (token: any) => {
  retryWrapper(axios, { retry_time: 1 });
  const noPropertiesDataEndPoint = getUrl(EMPTY_PROPERTIES_ENDPOINT);
  const options = {
    headers: getCommonHeaders(token),
  };
  let noPropertiesDataResponse: any;
  try {
    noPropertiesDataResponse = await axios.get(
      noPropertiesDataEndPoint,
      options
    );
    return noPropertiesDataResponse?.data;
  } catch (e: any) {
    return apiErrorResponseHandling(e);
  }
};

export const getPaymentsData = async (token: any, payload: number) => {
  retryWrapper(axios, { retry_time: 1 });
  const paymentsDataEndPoint = getUrl(PAYMENT_DATA_ENDPOINT);
  const options = {
    headers: getCommonHeaders(token),
  };
  let paymentsDataResponse: any;
  try {
    paymentsDataResponse = await axios.post(
      paymentsDataEndPoint,
      payload,
      options
    );
    if ([401, 403].indexOf(paymentsDataResponse.status) !== -1) {
      return 403;
    }
    if ([200, 201].indexOf(paymentsDataResponse.data.statusCode) === -1) {
      return null;
    }
    const parsedResponse = paymentsDataParser(
      paymentsDataResponse?.data?.data?.data
    );
    return {
      paymentList: parsedResponse,
      totalPage: paymentsDataResponse?.data?.data?.totalPages,
    };
  } catch (e: any) {
    return apiErrorResponseHandling(e);
  }
};

export const getStatementsData = async (token: any, payload: any) => {
  retryWrapper(axios, { retry_time: 1 });
  const statementsDataEndPoint = getUrl(STATEMENTS_DATA_ENDPOINT);
  const options = {
    headers: getCommonHeaders(token),
  };
  let statementsDataResponse: any;
  try {
    statementsDataResponse = await axios.post(
      statementsDataEndPoint,
      payload,
      options
    );
    if ([401, 403].indexOf(statementsDataResponse.status) !== -1) {
      return 403;
    }
    if ([200, 201].indexOf(statementsDataResponse.data.statusCode) === -1) {
      return null;
    }
    const parsedResponse = statementsDataParser(
      statementsDataResponse?.data?.data?.data
    );
    return {
      statementList: parsedResponse,
      totalPage: Math.ceil(statementsDataResponse?.data?.data?.total_pages),
    };
  } catch (e: any) {
    return apiErrorResponseHandling(e);
  }
};

export const getServiceFee = async (token: any, payload: any) => {
  retryWrapper(axios, { retry_time: 1 });
  const statementsDataEndPoint = getUrl(SERVICE_FEE_ENDPOINT);
  const options = {
    headers: getCommonHeaders(token),
  };
  let serviceFeeResponse: any;
  try {
    serviceFeeResponse = await axios.post(
      statementsDataEndPoint,
      payload,
      options
    );
    if ([401, 403].indexOf(serviceFeeResponse.status) !== -1) {
      return 403;
    }
    if ([200, 201].indexOf(serviceFeeResponse.data.statusCode) === -1) {
      return null;
    }
    return serviceFeeResponse?.data?.data ?? {};
  } catch (e: any) {
    return apiErrorResponseHandling(e);
  }
};

export const getPaymentStatusDetailsData = async (token: any) => {
  retryWrapper(axios, { retry_time: 1 });
  const statusDetailsEndPoint = getUrl(PAYMENT_STATUS_DETAILS_ENDPOINT);
  const options = {
    headers: getCommonHeaders(token),
  };
  let statusDetailsResponse: any;
  try {
    // statusDetailsResponse = await axios.get(
    //   statementsDataEndPoint,
    //   options
    // );
    const parsedResponse = statusDetailsParser(statusDetailsResponse?.data);
    return parsedResponse;
  } catch (e: any) {
    return apiErrorResponseHandling(e);
  }
};

export const createServiceFeePayment = async (token: any, payload: any) => {
  retryWrapper(axios, { retry_time: 1 });
  const createServiceFeeEndpoint = getUrl(CREATE_SERVICE_FEE_ENDPOINT);
  const options = {
    headers: getCommonHeaders(token),
  };
  let createServicePaymentResponse: any;
  try {
    createServicePaymentResponse = await axios.post(
      createServiceFeeEndpoint,
      payload,
      options
    );
    if ([401, 403].indexOf(createServicePaymentResponse.status) !== -1) {
      return 403;
    }
    if (
      [200, 201].indexOf(createServicePaymentResponse.data.statusCode) === -1
    ) {
      return null;
    }
    return createServicePaymentResponse?.data?.data;
  } catch (e: any) {
    return apiErrorResponseHandling(e);
  }
};

export const updateServiceFeePayment = async (token: any, payload: any) => {
  retryWrapper(axios, { retry_time: 1 });
  const updateServiceFeePaymentEndpoint = getUrl(
    UPDATE_SERVICE_FEE_PAYMENT_ENDPOINT
  );
  const options = {
    headers: getCommonHeaders(token),
  };
  let updateServiceFeePaymentResponse: any;
  try {
    updateServiceFeePaymentResponse = await axios.post(
      updateServiceFeePaymentEndpoint,
      payload,
      options
    );
    if ([401, 403].indexOf(updateServiceFeePaymentResponse.status) !== -1) {
      return 403;
    }
    if (
      [200, 201].indexOf(updateServiceFeePaymentResponse.data.statusCode) === -1
    ) {
      return null;
    }
    return updateServiceFeePaymentResponse?.data?.data;
  } catch (e: any) {
    return apiErrorResponseHandling(e);
  }
};

export const getFilterOptions = async (token: any, payload: any) => {
  retryWrapper(axios, { retry_time: 1 });
  const filterOptionsEndpoint = getUrl(SERVICE_FEE_FILTER_OPTIONS_ENDPOINT);
  const options = {
    headers: getCommonHeaders(token),
  };
  let filterOptionsResponse: any;
  try {
    filterOptionsResponse = await axios.post(
      filterOptionsEndpoint,
      payload,
      options
    );
    if ([401, 403].indexOf(filterOptionsResponse.status) !== -1) {
      return 403;
    }
    if ([200, 201].indexOf(filterOptionsResponse.data.statusCode) === -1) {
      return null;
    }
    const parsedResponse: any = parseFilterResponse(
      filterOptionsResponse.data?.data
    );
    return parsedResponse;
  } catch (e: any) {
    return apiErrorResponseHandling(e);
  }
};

// version 2.0 Api Service
export const createServiceRequestVersionTwo = async (
  apiRequestBody: any,
  token?: any
): Promise<any> => {
  retryWrapper(axios, { retry_time: 1 });
  apiRequestBody.referenceId = store.getState().user?.account?.PersonEmail;
  const serviceRequestCreationEndpoint = getUrl(
    SERVICE_REQUEST_CREATION_ENDPOINT_VERSION
  );
  const options = {
    headers: getCommonHeaders(token),
  };
  try {
    const serviceRequestSearchResponse = await axios.post(
      serviceRequestCreationEndpoint,
      apiRequestBody,
      options
    );
    if ([401, 403].indexOf(serviceRequestSearchResponse.status) !== -1) {
      return 403;
    }
    if (
      [200, 201].indexOf(serviceRequestSearchResponse.data.statusCode) === -1
    ) {
      return {
        errorCode: serviceRequestSearchResponse.data.statusCode,
      };
    }
    return serviceRequestSearchResponse;
  } catch (e: any) {
    if ([401, 403].indexOf(e.response?.status) !== -1) {
      return 403;
    }
    if ([406].indexOf(e.response?.status) !== -1) {
      return {
        errorCode: 406,
      };
    }
    return null;
  }
};
export const getServiceRequestsEligibiltyVersionTwo = async (
  apiRequestBody: any,
  token?: any
): Promise<any> => {
  retryWrapper(axios, { retry_time: 1 });
  apiRequestBody.referenceId = store.getState().user?.account?.PersonEmail;
  const serviceRequestSearchEndpoint = getUrl(
    SERVICE_REQUEST_ELIGIBILITY_ENDPOINT_VERSION_TWO
  );
  const options = {
    headers: getCommonHeaders(token),
  };
  try {
    const serviceRequestEligibilityResponse = await axios.post(
      serviceRequestSearchEndpoint,
      apiRequestBody,
      options
    );
    if ([401, 403].indexOf(serviceRequestEligibilityResponse.status) !== -1) {
      return 403;
    }
    if (
      [200, 201].indexOf(serviceRequestEligibilityResponse.data.statusCode) ===
      -1
    ) {
      return null;
    }
    return serviceRequestEligibilityResponse?.data;
  } catch (e: any) {
    if ([401, 403].indexOf(e.response?.status) !== -1) {
      return 403;
    }
    return null;
  }
};

export const getServiceRequestCatalogueVersionTwo = async (
  apiRequestBody: any,
  token?: any
): Promise<any> => {
  retryWrapper(axios, { retry_time: 1 });
  apiRequestBody.referenceId = store.getState().user?.account?.PersonEmail;
  const serviceRequestCatalog = getUrl(
    SERVICE_REQUEST_GET_CATALOGUE_END_VERSION_TWO
  );
  const options = {
    headers: getCommonHeaders(token),
  };
  try {
    const serviceRequestCatalogResponse = await axios.post(
      serviceRequestCatalog,
      apiRequestBody,
      options
    );
    if ([401, 403].indexOf(serviceRequestCatalogResponse.status) !== -1) {
      return 403;
    }
    if (
      [200, 201].indexOf(serviceRequestCatalogResponse.data.statusCode) === -1
    ) {
      return null;
    }
    return serviceRequestCatalogResponse;
  } catch (e: any) {
    if ([401, 403].indexOf(e.response?.status) !== -1) {
      return 403;
    }
    return null;
  }
};

export const getServiceRequestUploadVersionTwo = async (
  payload: any,
  token: string,
  onUploadProgress?: (progressEvent: ProgressEvent) => void
): Promise<any> => {
  payload.referenceId = store.getState().user?.account?.PersonEmail;
  try {
    const apiEndpoint: any = SIGNZY_BASE_URL + PATH.SERVICE_REQUEST_UPLOAD;
    const options: any = {
      headers: getHeaderForDocUpload(token),
      onUploadProgress,
    };
    const apiResponse = await axios.post(apiEndpoint, payload, options);
    if ([401, 403].indexOf(apiResponse.status) !== -1) {
      return 403;
    }
    if ([200, 201].indexOf(apiResponse.data.statusCode) === -1) {
      return apiResponse.data;
    }
    return apiResponse;
  } catch (e: any) {
    return signzyServiceErrorHandler(e);
  }
};

export const getAppointmentSlots = async (
  apiRequestBody?: any,
  token?: any
): Promise<any> => {
  retryWrapper(axios, { retry_time: 1 });
  apiRequestBody.referenceId = store.getState().user?.account?.PersonEmail;
  const serviceRequestAppointmentSlots = getUrl(
    SERVICE_REQUEST_APPOINTMENT_SLOTS_VERSION_TWO
  );
  const options = {
    headers: getCommonHeaders(token),
  };
  try {
    const serviceRequestAppointmentSlotsResponse = await axios.post(
      serviceRequestAppointmentSlots,
      apiRequestBody,
      options
    );
    if (
      [401, 403].indexOf(serviceRequestAppointmentSlotsResponse.status) !== -1
    ) {
      return 403;
    }
    if (
      [200, 201].indexOf(
        serviceRequestAppointmentSlotsResponse.data.statusCode
      ) === -1
    ) {
      return serviceRequestAppointmentSlotsResponse;
    }
    return serviceRequestAppointmentSlotsResponse;
  } catch (e: any) {
    if ([401, 403].indexOf(e.response?.status) !== -1) {
      return 403;
    }
    return null;
  }
};
export const getLiveTracking = async (
  apiRequestBody?: any,
  token?: any
): Promise<any> => {
  retryWrapper(axios, { retry_time: 1 });
  apiRequestBody.referenceId = store.getState().user?.account?.PersonEmail;
  const serviceRequestAppointmentSlots = getUrl(
    SERVICE_REQUEST_LIVE_TRACKING_VERSION_TWO
  );
  const options = {
    headers: getCommonHeaders(token),
  };
  try {
    const serviceRequestAppointmentSlotsResponse = await axios.post(
      serviceRequestAppointmentSlots,
      apiRequestBody,
      options
    );
    if (
      [401, 403].indexOf(serviceRequestAppointmentSlotsResponse.status) !== -1
    ) {
      return 403;
    }
    if (
      [200, 201].indexOf(
        serviceRequestAppointmentSlotsResponse.data.statusCode
      ) === -1
    ) {
      return null;
    }
    return serviceRequestAppointmentSlotsResponse;
  } catch (e: any) {
    if ([401, 403].indexOf(e.response?.status) !== -1) {
      return 403;
    }
    return null;
  }
};

export const appointmentSchedule = async (
  apiRequestBody?: any,
  token?: any
): Promise<any> => {
  retryWrapper(axios, { retry_time: 1 });
  apiRequestBody.referenceId = store.getState().user?.account?.PersonEmail;
  const serviceRequestAppointmentSchedule = getUrl(
    SERVICE_REQUEST_APPOINTMENT_SCHEDULE_VERSION_TWO
  );
  const options = {
    headers: getCommonHeaders(token),
  };
  try {
    const serviceRequestAppointmentScheduleResponse = await axios.post(
      serviceRequestAppointmentSchedule,
      apiRequestBody,
      options
    );
    return serviceRequestAppointmentScheduleResponse;
  } catch (e: any) {
    if ([401, 403].indexOf(e.response?.status) !== -1) {
      return 403;
    }
    return null;
  }
};

export const getServiceRequestDetails = async (
  apiRequestBody?: any,
  token?: any
): Promise<any> => {
  retryWrapper(axios, { retry_time: 1 });
  apiRequestBody.referenceId = store.getState().user?.account?.PersonEmail;
  const serviceRequestDetails = getUrl(SERVICE_REQUEST_DETAILS_VERSION_TWO);
  const options = {
    headers: getCommonHeaders(token),
  };
  try {
    const serviceRequestDetailsResponse = await axios.post(
      serviceRequestDetails,
      apiRequestBody,
      options
    );
    if ([401, 403].indexOf(serviceRequestDetailsResponse.status) !== -1) {
      return 403;
    }
    if (
      [200, 201].indexOf(serviceRequestDetailsResponse.data.statusCode) === -1
    ) {
      return null;
    }
    return serviceRequestDetailsResponse;
  } catch (e: any) {
    if ([401, 403].indexOf(e.response?.status) !== -1) {
      return 403;
    }
    return null;
  }
};

export const cancelServiceRequest = async (
  apiRequestBody?: any,
  token?: any
): Promise<any> => {
  retryWrapper(axios, { retry_time: 1 });
  apiRequestBody.referenceId = store.getState().user?.account?.PersonEmail;
  const cancelServiceRequest = getUrl(SERVICE_REQUEST_CANCEL_VERSION_TWO);
  const options = {
    headers: getCommonHeaders(token),
  };
  try {
    const cancelServiceRequestResponse = await axios.post(
      cancelServiceRequest,
      apiRequestBody,
      options
    );
    return cancelServiceRequestResponse;
  } catch (e: any) {
    if ([401, 403].indexOf(e.response?.status) !== -1) {
      return 403;
    }
    return null;
  }
};
export const getStatementServiceChargeDetails = async (
  token: any,
  payload: any
) => {
  retryWrapper(axios, { retry_time: 1 });
  const statementDetailsEndPoint = getUrl(
    STATEMENT_SERVICE_CHARGE_DETAILS_ENDPOINT
  );
  const options = {
    headers: getCommonHeaders(token),
  };
  let statementDetailsResponse: any;
  try {
    statementDetailsResponse = await axios.post(
      statementDetailsEndPoint,
      payload,
      options
    );
    if ([401, 403].indexOf(statementDetailsResponse.status) !== -1) {
      return 403;
    }
    if ([200, 201].indexOf(statementDetailsResponse.data.statusCode) === -1) {
      return null;
    }
    const summaryDataResponse = summaryDataParser(
      statementDetailsResponse?.data?.data[0]
    );
    const cardDetailsResponse = cardDetailsParser(
      statementDetailsResponse?.data?.data[0]
    );
    return { summaryData: summaryDataResponse, cardData: cardDetailsResponse };
  } catch (e: any) {
    return apiErrorResponseHandling(e);
  }
};

export const getStatementDetailsPdf = async (token: any, payload: any) => {
  retryWrapper(axios, { retry_time: 1 });
  const statementPDfEndpoint = getUrl(
    SERVICE_FEE_STATEMENT_DETAILS_PDF_ENDPOINT
  );
  const options = {
    headers: getCommonHeaders(token),
  };
  let statementDetailsPdfResponse: any;
  try {
    statementDetailsPdfResponse = await axios.post(
      statementPDfEndpoint,
      payload,
      options
    );
    if ([401, 403].indexOf(statementDetailsPdfResponse.status) !== -1) {
      return 403;
    }
    if (
      [200, 201].indexOf(statementDetailsPdfResponse.data.statusCode) === -1
    ) {
      return null;
    }
    return statementDetailsPdfResponse.data?.data;
  } catch (e: any) {
    return apiErrorResponseHandling(e);
  }
};

export const getPaymentSummaryData = async (token: any, payload: any) => {
  retryWrapper(axios, { retry_time: 1 });
  const summaryDataEndpoint = getUrl(SERVICE_FEE_PAYMENT_SUMMARY_ENDPOINT);
  const options = {
    headers: getCommonHeaders(token),
  };
  let summaryDetailsResponse: any;
  try {
    summaryDetailsResponse = await axios.post(
      summaryDataEndpoint,
      payload,
      options
    );
    if ([401, 403].indexOf(summaryDetailsResponse.status) !== -1) {
      return 403;
    }
    if ([200, 201].indexOf(summaryDetailsResponse.data.statusCode) === -1) {
      return null;
    }
    const parsedResponse: any = parseSummaryDataResponse(
      summaryDetailsResponse.data?.data
    );
    return parsedResponse;
  } catch (e: any) {
    return apiErrorResponseHandling(e);
  }
};

export const getPaymentStatusData = async (token: any, payload: any) => {
  retryWrapper(axios, { retry_time: 1 });
  const paymentStatusDetailsEndpoint = getUrl(PAYMENT_STATUS_DETAILS_ENDPOINT);
  const options = {
    headers: getCommonHeaders(token),
  };
  let statusDetailsResponse: any;
  try {
    statusDetailsResponse = await axios.get(
      `${paymentStatusDetailsEndpoint}/${payload.transactionId}?referenceId=${payload?.referenceId}&customerId=${payload?.customerId}`,
      options
    );
    if ([401, 403].indexOf(statusDetailsResponse.status) !== -1) {
      return 403;
    }
    if ([200, 201].indexOf(statusDetailsResponse.data.statusCode) === -1) {
      return null;
    }
    const parsedResponse: any = parseStatusDetailsResponse(
      statusDetailsResponse.data?.data
    );
    return parsedResponse;
  } catch (e: any) {
    return apiErrorResponseHandling(e);
  }
};

export const getDarnaPointDetails = async (
  mail: string | string[],
  token?: any,
  mobileNumber?: string,
  customerId?: string
): Promise<any> => {
  retryWrapper(axios, { retry_time: 1 });
  const apiRequestBody = {
    referenceId: mail,
    emailId: mail,
    mobileNumber: mobileNumber,
    customerId: customerId,
  };
  try {
    const getDarnaPointDetailsEndpoint = getUrl(DARNAPOINT_DETAILS_ENDPOINT);
    const options = {
      headers: getCommonHeaders(token),
    };
    const DarnaPointDetails = await axios.post(
      getDarnaPointDetailsEndpoint,
      apiRequestBody,
      options
    );
    if ([401, 403].indexOf(DarnaPointDetails.status) !== -1) {
      return 403;
    }
    if ([200, 201].indexOf(DarnaPointDetails.status) === -1) {
      return null;
    }

    return DarnaPointDetails;
  } catch (e: any) {
    return apiErrorResponseHandling(e);
  }
};

export const getProjectList = async (
  customerId?: string,
  referenceId?: string,
  token?: any,
): Promise<any> => {
  retryWrapper(axios, { retry_time: 1 });
  const apiRequestBody = {
    referenceId: referenceId,
    customerId: customerId,
  };
  try {
    const getProjectListEndpoint = getUrl(SALES_JOURNEY_PROJECT_LIST_ENDPOINT);
    const options = {
      headers: getCommonHeaders(token),
    };
    const projectList = await axios.post(
      getProjectListEndpoint,
      apiRequestBody,
      options
    );
    if ([401, 403].indexOf(projectList.status) !== -1) {
      return 403;
    }
    if ([200, 201].indexOf(projectList.status) === -1) {
      return null;
    }

    return projectList?.data;
  } catch (e: any) {
    return apiErrorResponseHandling(e);
  }
};

export const endpointGenerator = async (
  payload: any,
  token?: any,
): Promise<any> => {
  retryWrapper(axios, { retry_time: 1 });
  try {
    const getEndPoint = getUrl(SALES_JOURNEY_ENDPOINT_GENERATOR);
    const options = {
      headers: getCommonHeaders(token),
    };
    const endPoint = await axios.post(
      getEndPoint,
      payload,
      options
    );
    if ([401, 403].indexOf(endPoint.status) !== -1) {
      return 403;
    }
    if ([200, 201].indexOf(endPoint.status) === -1) {
      return null;
    }

    return endPoint?.data;
  } catch (e: any) {
    return apiErrorResponseHandling(e);
  }
};

export const spaUploadEmiratesIdFront = async (payload: any, token: string) => {
  try {
    const getEndPoint = getUrl(SPA_EMIRATES_ID_FRONT_ENPOINT);
    const options = {
      headers: getHeaderForDocUpload(token),
    };
    const apiResponse = await axios.post(getEndPoint, payload, options);
    if ([401, 403].indexOf(apiResponse.status) !== -1) {
      return 403;
    }
    if ([200, 201].indexOf(apiResponse.data.statusCode) === -1) {
      return apiResponse.data;
    }
    return apiResponse;
  } catch (e: any) {
    return signzyServiceErrorHandler(e);
  }
};

export const spaUploadEmiratesIdBack = async (payload: any, token: string) => {
  try {
    const getEndPoint = getUrl(SPA_EMIRATES_ID_BACK_ENPOINT);
    const options = {
      headers: getHeaderForDocUpload(token),
    };
    const apiResponse = await axios.post(getEndPoint, payload, options);
    if ([401, 403].indexOf(apiResponse.status) !== -1) {
      return 403;
    }
    if ([200, 201].indexOf(apiResponse.data.statusCode) === -1) {
      return apiResponse.data;
    }
    return apiResponse;
  } catch (e: any) {
    return signzyServiceErrorHandler(e);
  }
};

//SPA upload passport
export const spaUploadPassport = async (payload: any, token: string) => {
  try {
    const getEndPoint = getUrl(SPA_PASSPORT_UPLOAD_ENPOINT);

    const options = {
      headers: getHeaderForDocUpload(token),
    };

    const apiResponse = await axios.post(getEndPoint, payload, options);
    if ([401, 403].indexOf(apiResponse.status) !== -1) {
      return 403;
    }
    if ([200, 201].indexOf(apiResponse.data.statusCode) === -1) {
      return apiResponse.data;
    }
    return apiResponse;
  } catch (e: any) {
    return signzyServiceErrorHandler(e);
  }
};

// SPA Liveness API to get signzy iframe URL
export const spaCheckLiveliness = async (payload: any, token: string) => {
  try {
    const apiEndpoint: any = SIGNZY_BASE_URL + PATH.SPA_CHECK_LIVENESS;
    const options = {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "POST, GET, OPTIONS, DELETE",
        "Content-Type": "application/json",
        Authorization: `Bearer ${decryptToken(token)
          ? decryptToken(token)
          : store.getState().user.token
          }`,
      },
    };

    const apiResponse = await axios.post(
      apiEndpoint,
      JSON.stringify(payload),
      options
    );
    if ([401, 403].indexOf(apiResponse.status) !== -1) {
      return 403;
    }
    if ([200, 201].indexOf(apiResponse.data.statusCode) === -1) {
      return apiResponse.data;
    }
    return apiResponse;
  } catch (e: any) {
    return signzyServiceErrorHandler(e);
  }
};

// SPA Details update
export const setSPADetails = async (payload: any, token: string) => {
  const apiEndpoint: any = getUrl(SPA_SET_DETAILS_ENPOINT);
  const options = {
    headers: getCommonHeaders(token),
  };
  try {
    const apiResponse = await axios.post(apiEndpoint, payload, options);
    if ([401, 403].indexOf(apiResponse.status) !== -1) {
      return 403;
    }
    if ([200, 201].indexOf(apiResponse.data.statusCode) === -1) {
      return apiResponse;
    }
    return apiResponse;
  } catch (e: any) {
    if ([401, 403].indexOf(e.response?.status) !== -1) {
      return 403;
    }
    return null;
  }
};

// Parameters to pass back to investment graph data API payload
export const investmentPortfolioParams = async (payload: any, token: string) => {
  const apiEndpoint: any = getUrl(INVESTMENT_PORTFOLIO_PARAMS_ENDPOINT);
  const options = {
    headers: getCommonHeaders(token),
  };
  try {
    const apiResponse = await axios.post(apiEndpoint, payload, options);
    if ([401, 403].indexOf(apiResponse.status) !== -1) {
      return 403;
    }
    if ([200, 201].indexOf(apiResponse.data.statusCode) === -1) {
      return apiResponse;
    }
    return apiResponse;
  } catch (e: any) {
    if ([401, 403].indexOf(e.response?.status) !== -1) {
      return 403;
    }
    return null;
  }
};

// Investment portfolio graph data
export const investmentPortfolioGraph = async (payload: any, token: string) => {
  const apiEndpoint: any = getUrl(INVESTMENT_PORTFOLIO_GRAPH_DATA_ENDPOINT);
  const options = {
    headers: getCommonHeaders(token),
  };
  try {
    const apiResponse = await axios.post(apiEndpoint, payload, options);
    if ([401, 403].indexOf(apiResponse.status) !== -1) {
      return 403;
    }
    if ([200, 201].indexOf(apiResponse.data.statusCode) === -1) {
      return apiResponse;
    }
    return apiResponse;
  } catch (e: any) {
    if ([401, 403].indexOf(e.response?.status) !== -1) {
      return 403;
    }
    return null;
  }
};

// Investment portfolio graph data
export const userPortfolioGraph = async (payload: any, token: string) => {
  const apiEndpoint: any = getUrl(USER_PORTFOLIO_GRAPH_DATA_ENDPOINT);
  const options = {
    headers: getCommonHeaders(token),
  };
  try {
    const apiResponse = await axios.post(apiEndpoint, payload, options);
    if ([401, 403].indexOf(apiResponse.status) !== -1) {
      return 403;
    }
    if ([200, 201].indexOf(apiResponse.data.statusCode) === -1) {
      return apiResponse;
    }
    return apiResponse;
  } catch (e: any) {
    if ([401, 403].indexOf(e.response?.status) !== -1) {
      return 403;
    }
    return null;
  }
};

export const getCatalogueAMCList = async (
  apiRequestBody: any,
  token?: any
): Promise<any> => {
  retryWrapper(axios, { retry_time: 1 });
  apiRequestBody.referenceId = store.getState().user?.account?.PersonEmail;
  const serviceRequestCatalogAMCList = getUrl(
    SERVICE_REQUEST_GET_CATALOGUE_AMC_LIST
  );
  const options = {
    headers: getCommonHeaders(token),
  };
  try {
    const amcListResponse = await axios.post(
      serviceRequestCatalogAMCList,
      apiRequestBody,
      options
    );
    if ([401, 403].indexOf(amcListResponse.status) !== -1) {
      return 403;
    }
    if (
      [200, 201].indexOf(amcListResponse.data.statusCode) === -1
    ) {
      return null;
    }
    return amcListResponse?.data?.data;
  } catch (e: any) {
    if ([401, 403].indexOf(e.response?.status) !== -1) {
      return 403;
    }
    return null;
  }
};

export const getServiceRequestConfigV2 = async (
  apiRequestBody: any,
  token?: any
): Promise<any> => {
  retryWrapper(axios, { retry_time: 1 });
  apiRequestBody.referenceId = store.getState().user?.account?.PersonEmail;
  const serviceRequestConfigUrl = getUrl(SERVICE_REQUEST_CONFIG_V2_ENDPOINT);
  const options = {
    headers: getCommonHeaders(token),
  };
  try {
    const configResponse = await axios.post(
      serviceRequestConfigUrl,
      apiRequestBody,
      options
    );
    if ([401, 403].indexOf(configResponse.status) !== -1) {
      return 403;
    }
    // if ([200, 201].indexOf(configResponse.statusCode) === -1) {
    //   return null;
    // }
    return configResponse?.data;
  } catch (e: any) {
    if ([401, 403].indexOf(e.response?.status) !== -1) {
      return 403;
    }
    return null;
  }
};

export const requestReOpen = async (
  payload: any,
  token?: any,
): Promise<any> => {
  retryWrapper(axios, { retry_time: 1 });
  try {
    const serviceReOpenURL = getUrl(SERVICE_ENDPOINT_REOPEN_ENDPOINT);
    const options = {
      headers: getCommonHeaders(token),
    };
    const isReOpened = await axios.post(
      serviceReOpenURL,
      payload,
      options
    );
    if ([401, 403].indexOf(isReOpened.status) !== -1) {
      return 403;
    }
    if ([200, 201].indexOf(isReOpened.status) === -1) {
      return null;
    }

    return isReOpened?.data;
  } catch (e: any) {
    return apiErrorResponseHandling(e);
  }
};

export const getFeatureFlags = async (): Promise<any> => {
  retryWrapper(axios, { retry_time: 1 });
  try {
    const getFeatureFlagEndpoint = getUrl(GET_FEATURE_FLAG_ENDPOINT);

    const featureFlags = await axios.get(
      getFeatureFlagEndpoint);
    return featureFlags?.data;
  } catch (e: any) {
    return apiErrorResponseHandling(e);
  }
};

export const getConfigurableContent = async () => {
  const apiEndpoint: any = getUrl(CONFIGURABLE_CONTENTS_ENDPOINT);
  try {
    const apiResponse = await axios.get(`${apiEndpoint}?v=${Date.now()}`);
    if ([401, 403].indexOf(apiResponse.status) !== -1) {
      return 403;
    }
    if ([200, 201].indexOf(apiResponse.data.statusCode) === -1) {
      return apiResponse;
    }
    return apiResponse;
  } catch (e: any) {
    if ([401, 403].indexOf(e.response?.status) !== -1) {
      return 403;
    }
    return null;
  }
};

// User portfolio and Market trends new APIs
export const getMarketTrendFilters = async (payload: any, token: string) => {
  const apiEndpoint: any = getUrl(MARKET_TREND_FILTERS_ENDPOINT);
  const options = {
    headers: getCommonHeaders(token),
  };
  try {
    const apiResponse = await axios.post(apiEndpoint, payload, options);
    if ([401, 403].indexOf(apiResponse.status) !== -1) {
      return 403;
    }
    if ([200, 201].indexOf(apiResponse.data.statusCode) === -1) {
      return apiResponse;
    }
    return apiResponse;
  } catch (e: any) {
    if ([401, 403].indexOf(e.response?.status) !== -1) {
      return 403;
    }
    return null;
  }
};

export const getMarketTrends = async (payload: any, token: string) => {
  const apiEndpoint: any = getUrl(MARKET_TREND_ENDPOINT);
  const options = {
    headers: getCommonHeaders(token),
  };
  try {
    const apiResponse = await axios.post(apiEndpoint, payload, options);
    if ([401, 403].indexOf(apiResponse.status) !== -1) {
      return 403;
    }
    if ([200, 201].indexOf(apiResponse.data.statusCode) === -1) {
      return apiResponse;
    }
    return apiResponse;
  } catch (e: any) {
    if ([401, 403].indexOf(e.response?.status) !== -1) {
      return 403;
    }
    return null;
  }
};

export const getUserPortfolio = async (payload: any, token: string) => {
  const apiEndpoint: any = getUrl(USER_PORTFOLIO_GRAPH_ENDPOINT);
  const options = {
    headers: getCommonHeaders(token),
  };
  try {
    const apiResponse = await axios.post(apiEndpoint, payload, options);
    if ([401, 403].indexOf(apiResponse.status) !== -1) {
      return 403;
    }
    if ([200, 201].indexOf(apiResponse.data.statusCode) === -1) {
      return apiResponse;
    }
    return apiResponse;
  } catch (e: any) {
    if ([401, 403].indexOf(e.response?.status) !== -1) {
      return 403;
    }
    return null;
  }
};
//Digital Sales
export const digitalSalesLockUnit = async (apiRequestBody: any, token: string) => {
  apiRequestBody.referenceId = store.getState().user?.account?.PersonEmail;
  const apiEndpoint: any = getUrl(DIGITAl_SALES_UNIT_LOCKING_ENPOINT);
  const options = {
    headers: getCommonHeaders(token),
  };
  try {
    const apiResponse = await axios.post(apiEndpoint, apiRequestBody, options);
    if ([401, 403].indexOf(apiResponse.status) !== -1) {
      return 403;
    }
    if ([200, 201].indexOf(apiResponse.data.statusCode) === -1) {
      return apiResponse;
    }
    return apiResponse;
  } catch (e: any) {
    if ([401, 403].indexOf(e.response?.status) !== -1) {
      return 403;
    }
    return null;
  }
};
export const getDigitalSalesUnitDetails = async (apiRequestBody: any, token: string) => {
  apiRequestBody.referenceId = store.getState().user?.account?.PersonEmail;
  const apiEndpoint: any = getUrl(DIGITAl_SALES_UNIT_DETAILS_ENPOINT);
  const options = {
    headers: getCommonHeaders(token),
  };
  try {
    const apiResponse = await axios.post(apiEndpoint, apiRequestBody, options);
    if ([401, 403].indexOf(apiResponse.status) !== -1) {
      return 403;
    }
    if ([200, 201].indexOf(apiResponse.data.statusCode) === -1) {
      return apiResponse;
    }
    return apiResponse;
  } catch (e: any) {
    if ([401, 403].indexOf(e.response?.status) !== -1) {
      return 403;
    }
    return null;
  }
};

export const getDigitalSalesPaymentPlans = async (apiRequestBody: any, token: string) => {
  apiRequestBody.referenceId = store.getState().user?.account?.PersonEmail;
  const apiEndpoint: any = getUrl(DIGITAl_SALES_PAYMENT_PLANS_ENPOINT);
  const options = {
    headers: getCommonHeaders(token),
  };
  try {
    const apiResponse = await axios.post(apiEndpoint, apiRequestBody, options);
    if ([401, 403].indexOf(apiResponse.status) !== -1) {
      return 403;
    }
    if ([200, 201].indexOf(apiResponse.data.statusCode) === -1) {
      return apiResponse;
    }
    return apiResponse;
  } catch (e: any) {
    if ([401, 403].indexOf(e.response?.status) !== -1) {
      return 403;
    }
    return null;
  }
};

export const getDigitalSalesPaymentDetails = async (apiRequestBody: any, token: string) => {
  apiRequestBody.referenceId = store.getState().user?.account?.PersonEmail;
  const apiEndpoint: any = getUrl(DIGITAl_SALES_PAYMENT_DETAILS_ENPOINT);
  const options = {
    headers: getCommonHeaders(token),
  };
  try {
    const apiResponse = await axios.post(apiEndpoint, apiRequestBody, options);
    if ([401, 403].indexOf(apiResponse.status) !== -1) {
      return 403;
    }
    if ([200, 201].indexOf(apiResponse.data.statusCode) === -1) {
      return apiResponse;
    }
    return apiResponse;
  } catch (e: any) {
    if ([401, 403].indexOf(e.response?.status) !== -1) {
      return 403;
    }
    return null;
  }
};

export const getPropertySearchFilters = async (payload: any, token: string) => {
  const apiEndpoint: any = getUrl(PROPERTY_SEARCH_FILTERS_ENPOINT);
  const options = {
    headers: getCommonHeaders(token),
  };
  try {
    const apiResponse = await axios.get(`${apiEndpoint}?${payload}`, options);
    if ([401, 403].indexOf(apiResponse.status) !== -1) {
      return 403;
    }
    if ([200, 201].indexOf(apiResponse.data.statusCode) === -1) {
      return apiResponse;
    }
    return apiResponse;
  } catch (e: any) {
    if ([401, 403].indexOf(e.response?.status) !== -1) {
      return 403;
    }
    return null;
  }
};

export const getPropertySearchSuggestions = async (payload: any, token: string) => {
  const apiEndpoint: any = getUrl(PROPERTY_SEARCH_SUGGESTIONS_ENPOINT);
  const options = {
    headers: getCommonHeaders(token),
  };
  try {
    const apiResponse = await axios.get(`${apiEndpoint}?${payload}`, options);
    if ([401, 403].indexOf(apiResponse.status) !== -1) {
      return 403;
    }
    if ([200, 201].indexOf(apiResponse.data.statusCode) === -1) {
      return apiResponse;
    }
    return apiResponse;
  } catch (e: any) {
    if ([401, 403].indexOf(e.response?.status) !== -1) {
      return 403;
    }
    return null;
  }
};

export const searchProperties = async (payload: any, token: string) => {
  const apiEndpoint: any = getUrl(PROPERTY_SEARCH_ENPOINT);
  const options = {
    headers: getCommonHeaders(token),
  };
  try {
    const apiResponse = await axios.get(`${apiEndpoint}?${payload}`, options);
    if ([401, 403].indexOf(apiResponse.status) !== -1) {
      return 403;
    }
    if ([200, 201].indexOf(apiResponse.data.statusCode) === -1) {
      return apiResponse;
    }
    return apiResponse;
  } catch (e: any) {
    if ([401, 403].indexOf(e.response?.status) !== -1) {
      return 403;
    }
    return null;
  }
};

export const getSalesRecord = async (apiRequestBody: any, token: string) => {
  apiRequestBody.referenceId = store.getState().user?.account?.PersonEmail;
  const apiEndpoint: any = getUrl(SALES_RECORDS_ENDPOINT);
  const options = {
    headers: getCommonHeaders(token),
  };
  try {
    const apiResponse = await axios.post(apiEndpoint, apiRequestBody, options);

    if ([401, 403].indexOf(apiResponse.status) !== -1) {
      return 403;
    }
    if ([200, 201].indexOf(apiResponse.status) === -1) {
      return apiResponse;
    }
    return apiResponse;
  } catch (e: any) {
    if ([401, 403].indexOf(e.response?.status) !== -1) {
      return 403;
    }
    return null;
  }
}

export const getDSCustomerDocument = async (apiRequestBody: any, token: string) => {
  apiRequestBody.referenceId = store.getState().user?.account?.PersonEmail;
  const apiEndpoint: any = getUrl(DS_CUSTOMER_DOCUMENT_ENDPOINT);
  const options = {
    headers: getCommonHeaders(token),
  };
  try {
    const apiResponse = await axios.post(apiEndpoint, apiRequestBody, options);
    if ([401, 403].indexOf(apiResponse.status) !== -1) {
      return 403;
    }
    if ([200, 201].indexOf(apiResponse.data.statusCode) === -1) {
      return apiResponse;
    }
    return apiResponse;
  } catch (e: any) {
    if ([401, 403].indexOf(e.response?.status) !== -1) {
      return 403;
    }
    return null;
  }
}

// Get encrypted symmetric key
export const getEncryptedSymmetricKey = async (payload: any, token: string, ENDPOINT: string) => {
  const apiEndpoint: any = getUrl(ENDPOINT);
  const options = {
    headers: getCommonHeaders(token),
  };
  try {
    const apiResponse = await axios.post(apiEndpoint, payload, options);
    if ([401, 403].indexOf(apiResponse.status) !== -1) {
      return 403;
    }
    if ([200, 201].indexOf(apiResponse.data.statusCode) === -1) {
      return apiResponse;
    }
    return apiResponse;
  } catch (e: any) {
    if ([401, 403].indexOf(e.response?.status) !== -1) {
      return 403;
    }
    return null;
  }
}

// Get encrypted symmetric key
export const getUAEPassInfo = async (payload: any, token: string) => {
  const apiEndpoint: any = getUrl(SPA_UAEPASS_INFO_ENPOINT);
  const options = {
    headers: getCommonHeaders(token),
  };
  try {
    const apiResponse = await axios.post(apiEndpoint, payload, options);
    if ([401, 403].indexOf(apiResponse.status) !== -1) {
      return 403;
    }
    if (
      !apiResponse.data.dataBlob && // Handle encryption
      [200, 201].indexOf(apiResponse.data.statusCode) === -1
    ) {
      return apiResponse;
    }
    return apiResponse;
  } catch (e: any) {
    if ([401, 403].indexOf(e.response?.status) !== -1) {
      return 403;
    }
    return null;
  }
}

export const getDocusignUrlAPIV2 = async (payload: any, token: string) => {
  const apiEndpoint: any = getUrl(DOCUSIGN_V2_ENDPOINT);
  const options = {
    headers: getCommonHeaders(token),
  };
  try {
    const apiResponse = await axios.post(apiEndpoint, payload, options);
    if ([401, 403].indexOf(apiResponse.status) !== -1) {
      return 403;
    }
    if (
      !apiResponse.data.dataBlob && // Handle encryption
      [200, 201].indexOf(apiResponse.data.statusCode) === -1
    ) {
      return apiResponse;
    }
    return apiResponse;
  } catch (e: any) {
    if ([401, 403].indexOf(e.response?.status) !== -1) {
      return 403;
    }
    return null;
  }
}

// SPA Details update
export const setSPADetailsV2 = async (payload: any, token: string) => {
  const apiEndpoint: any = getUrl(SPA_SET_DETAILS_V2_ENPOINT);
  const options = {
    headers: getCommonHeaders(token),
  };
  try {
    const apiResponse = await axios.post(apiEndpoint, payload, options);
    if ([401, 403].indexOf(apiResponse.status) !== -1) {
      return 403;
    }
    if ([200, 201].indexOf(apiResponse.data.statusCode) === -1) {
      return apiResponse;
    }
    return apiResponse;
  } catch (e: any) {
    if ([401, 403].indexOf(e.response?.status) !== -1) {
      return 403;
    }
    return null;
  }
};

//Profile Update flow
export const generateOTPForProfileUpdate = async (payload: any, token: string) => {
  const apiEndpoint: any = getUrl(PROFILE_UPDATE_GENERATE_OTP_ENDPOINT);
  const options = {
    headers: getCommonHeaders(token),
  };
  try {
    const apiResponse = await axios.post(apiEndpoint, payload, options);
    if ([401, 403].indexOf(apiResponse.status) !== -1) {
      return 403;
    }
    if ([200, 201].indexOf(apiResponse.data.statusCode) === -1) {
      return apiResponse;
    }
    return apiResponse;
  } catch (e: any) {
    if ([401, 403].indexOf(e.response?.status) !== -1) {
      return 403;
    }
    return null;
  }
};

export const resendOTPForProfileUpdate = async (payload: any, token: string) => {
  const apiEndpoint: any = getUrl(PROFILE_UPDATE_RESEND_OTP_ENDPOINT);
  const options = {
    headers: getCommonHeaders(token),
  };
  try {
    const apiResponse = await axios.post(apiEndpoint, payload, options);
    if ([401, 403].indexOf(apiResponse.status) !== -1) {
      return 403;
    }
    if ([200, 201].indexOf(apiResponse.data.statusCode) === -1) {
      return apiResponse;
    }
    return apiResponse;
  } catch (e: any) {
    if ([401, 403].indexOf(e.response?.status) !== -1) {
      return 403;
    }
    return null;
  }
};

export const validateOTPForProfileUpdate = async (payload: any, token: string) => {
  const apiEndpoint: any = getUrl(PROFILE_UPDATE_VALIDATE_OTP_ENDPOINT);
  const options = {
    headers: getCommonHeaders(token),
  };
  try {
    const apiResponse = await axios.post(apiEndpoint, payload, options);
    if ([401, 403].indexOf(apiResponse.status) !== -1) {
      return 403;
    }
    if ([200, 201].indexOf(apiResponse.data.statusCode) === -1) {
      return apiResponse;
    }
    return apiResponse;
  } catch (e: any) {
    if ([401, 403].indexOf(e.response?.status) !== -1) {
      return 403;
    }
    return null;
  }
};

export const extractPassportData = async (payload: any, token: string) => {
  const apiEndpoint: any = getUrl(EXTRACT_PASSPORT_DATA_ENDPOINT);
  const options = {
    headers: getHeaderForDocUpload(token),
  };
  try {
    const apiResponse = await axios.post(apiEndpoint, payload, options);
    if ([401, 403].indexOf(apiResponse.status) !== -1) {
      return 403;
    }
    if ([200, 201].indexOf(apiResponse.data.statusCode) === -1) {
      return apiResponse;
    }
    return apiResponse;
  } catch (e: any) {
    if ([401, 403].indexOf(e.response?.status) !== -1) {
      return 403;
    }
    return null;
  }
};

export const extractEmiratedIdData = async (payload: any, token: string) => {
  const apiEndpoint: any = getUrl(EXTRACT_EMIRATESID_DATA_ENDPOINT);
  const options = {
    headers: getHeaderForDocUpload(token),
  };
  try {
    const apiResponse = await axios.post(apiEndpoint, payload, options);
    if ([401, 403].indexOf(apiResponse.status) !== -1) {
      return 403;
    }
    if ([200, 201].indexOf(apiResponse.data.statusCode) === -1) {
      return apiResponse;
    }
    return apiResponse;
  } catch (e: any) {
    if ([401, 403].indexOf(e.response?.status) !== -1) {
      return 403;
    }
    return null;
  }
};

export const getPremiumInvList = async (
  payload:any,
  token?: any,
): Promise<any> => {
  retryWrapper(axios, { retry_time: 1 });
  try {
    const getPremiumInvListURL = getUrl(PREMIUM_PARKING_INVENTORY_ENDPOINT);
    const options = {
      headers: getCommonHeaders(token),
    };
    const getInvList = await axios.post(
      getPremiumInvListURL,
      payload,
      options
    );
    if ([401, 403].indexOf(getInvList.status) !== -1) {
      return 403;
    }
    if ([200, 201].indexOf(getInvList.status) === -1) {
      return null;
    }

    return getInvList?.data;
  } catch (e: any) {
    return apiErrorResponseHandling(e);
  }
};
export const getAddOns = async (
  payload:any,
  token?: any,
): Promise<any> => {
  retryWrapper(axios, { retry_time: 1 });
  try {
    const getAddOnsURL = getUrl(PREMIUM_PARKING_ADDONS_ENDPOINT);
    const options = {
      headers: getCommonHeaders(token),
    };
    const getAddOnsData = await axios.post(
      getAddOnsURL,
      payload,
      options
    );
    if ([401, 403].indexOf(getAddOnsData.status) !== -1) {
      return 403;
    }
    if ([200, 201].indexOf(getAddOnsData.status) === -1) {
      return null;
    }

    return getAddOnsData?.data;
  } catch (e: any) {
    return apiErrorResponseHandling(e);
  }
};
export const quoteAndLineItems = async (
  payload:any,
  token?: any,
): Promise<any> => {
  retryWrapper(axios, { retry_time: 1 });
  try {
    const getQuoteAndLineItemsURL = getUrl(PREMIUM_PARKING_QUOTE_AND_LINES_ITEM);
    const options: AxiosRequestConfig = {
      headers: getCommonHeaders(token),
    };
    const getAddOnsData = await axios.post(
      getQuoteAndLineItemsURL,
      payload,
      options
    );
    if ([401, 403].indexOf(getAddOnsData.status) !== -1) {
      return 403;
    }
    if ([200, 201].indexOf(getAddOnsData.status) === -1) {
      return null;
    }
    //intercept and decrypt encrypted data
    if(getAddOnsData?.data?.data){
      const decryptedData = decryptData(getAddOnsData?.data?.data, ORDER_SECRET_KEY )
      return decryptedData;
    }
    return null;
  } catch (e: any) {
    return apiErrorResponseHandling(e);
  }
};

export const parkingLeadCreate = async (
  payload:any,
  token?: any,
): Promise<any> => {
  retryWrapper(axios, { retry_time: 1 });
  try {
    const leadCreateURL = getUrl(PREMIUM_PARKING_LEAD_CREATE);
    const options = {
      headers: getCommonHeaders(token),
    };
    const createLeadResponse = await axios.post(
      leadCreateURL,
      payload,
      options
    );
    if ([401, 403].indexOf(createLeadResponse.status) !== -1) {
      return 403;
    }
    if ([200, 201].indexOf(createLeadResponse.status) === -1) {
      return null;
    }

    return createLeadResponse?.data;
  } catch (e: any) {
    return e;
    // return apiErrorResponseHandling(e);
  }
};

export const parkingOpportunity = async (
  payload:any,
  token?: any,
): Promise<any> => {
  retryWrapper(axios, { retry_time: 1 });
  try {
    const parkingOpportunityURL = getUrl(PREMIUM_PARKING_OPPORTUNITY);
    const options = {
      headers: getCommonHeaders(token),
    };
    const opportunityResponse = await axios.post(
      parkingOpportunityURL,
      payload,
      options
    );
    if ([401, 403].indexOf(opportunityResponse.status) !== -1) {
      return 403;
    }
    if ([200, 201].indexOf(opportunityResponse.status) === -1) {
      return null;
    }

    return opportunityResponse?.data;
  } catch (e: any) {
    return apiErrorResponseHandling(e);
  }
};

export const saveSelectedQuote = async (
  payload:any,
  token?: any,
): Promise<any> => {
  retryWrapper(axios, { retry_time: 1 });
  try {
    const saveQuoteURL = getUrl(PREMIUM_PARKING_SAVE_QUOTE);
    const options = {
      headers: getCommonHeaders(token),
    };
    const savedQuoteResponse = await axios.post(
      saveQuoteURL,
      payload,
      options
    );
    if ([401, 403].indexOf(savedQuoteResponse.status) !== -1) {
      return 403;
    }
    if ([200, 201].indexOf(savedQuoteResponse.status) === -1) {
      return null;
    }

    return savedQuoteResponse?.data;
  } catch (e: any) {
    return apiErrorResponseHandling(e);
  }
};

export const getQuoteAgreement = async (
  payload:any,
  token?: any,
): Promise<any> => {
  retryWrapper(axios, { retry_time: 1 });
  try {
    const getQuoteURL = getUrl(PREMIUM_PARKING_QUOTE_AGREEMENT);
    const options = {
      headers: getCommonHeaders(token),
    };
    const quoteAgreementResponse = await axios.post(
      getQuoteURL,
      payload,
      options
    );
    if ([401, 403].indexOf(quoteAgreementResponse.status) !== -1) {
      return 403;
    }
    if ([200, 201].indexOf(quoteAgreementResponse.status) === -1) {
      return null;
    }

    return quoteAgreementResponse?.data;
  } catch (e: any) {
    return apiErrorResponseHandling(e);
  }
};
export const getParkingProductContent = async (): Promise<any> => {
  retryWrapper(axios, { retry_time: 1 });
  try {
    const getParkingProductContentEndpoint = getUrl(PREMIUM_PARKING_PRODUCTS_CONTENT);

    const contents = await axios.get(
      getParkingProductContentEndpoint);
    return contents?.data;
  } catch (e: any) {
    return apiErrorResponseHandling(e);
  }
};

export const getParkingProductCost = async (): Promise<any> => {
  retryWrapper(axios, { retry_time: 1 });
  try {
    const getParkingProductCostEndpoint = getUrl(PREMIUM_PARKING_PRODUCTS_COST);

    const costDetails = await axios.get(
      getParkingProductCostEndpoint);
    return costDetails?.data;
  } catch (e: any) {
    return apiErrorResponseHandling(e);
  }
};

export const createParkingPayment = async (
  apiRequestBody: any,
  token?: any
): Promise<any> => {
  retryWrapper(axios, { retry_time: 1 });
  // apiRequestBody.referenceId = store.getState().user?.account?.PersonEmail;
  const createParkingPaymentEndpoint = getUrl(CREATE_PARKING_PAYMENT_ENDPOINT);
  const options = {
    headers: getCommonHeaders(token),
  };
  try {
    const createParkingPaymentResponse = await axios.post(
      createParkingPaymentEndpoint,
      apiRequestBody,
      options
    );
    if ([401, 403].indexOf(createParkingPaymentResponse.status) !== -1) {
      return 403;
    }
    // if ([200, 201].indexOf(createPaymentResponse.data.statusCode) === -1) {
    //     return null
    // }
   return decryptData(createParkingPaymentResponse?.data?.data, CARD_ENCRYPTION_SECRET_KEY);

  } catch (e: any) {
    if ([401, 403].indexOf(e.response?.status) !== -1) {
      return 403;
    }
    return null;
  }
};

export const getOrderDetails = async (
  data:any,
  token?: any,
): Promise<any> => {
  retryWrapper(axios, { retry_time: 1 });
  try {
    const url  = getUrl(PREMIUM_PARKING_ORDER_DETAILS);
    const options = {
      headers: getCommonHeaders(token),
    };
    const response  = await axios.post(
      url,
      data,
      options
    );

    if ([401, 403].indexOf(response.status) !== -1) {
      return 403;
    }
    if ([200, 201].indexOf(response.status) === -1) {
      return null;
    }

    // Decrypt and return response data
    return decryptData(response?.data?.data, ORDER_SECRET_KEY);

  } catch (e: any) {
    return apiErrorResponseHandling(e);
  }
}
export const setPremParkingDetails = async (
  payload:any,
  token?: any,
): Promise<any> => {
  retryWrapper(axios, { retry_time: 1 });
  try {
    const parkingDetailsURL = getUrl(PARKING_SET_PREM_PARKING_DETAILS_ENDPOINT);
    const options = {
      headers: getCommonHeaders(token),
    };
    const parkingDetailsResponse = await axios.post(
      parkingDetailsURL,
      payload,
      options
    );
    if ([401, 403].indexOf(parkingDetailsResponse.status) !== -1) {
      return 403;
    }
    if ([200, 201].indexOf(parkingDetailsResponse.status) === -1) {
      return null;
    }

    return parkingDetailsResponse?.data;
  } catch (e: any) {
    return apiErrorResponseHandling(e);
  }
};
export const getParkingOrders = async (payload: any, token: string) => {
  const apiEndpoint: any = getUrl(PARKING_ORDERS_ENDPOINT);
  const options = {
    headers: getCommonHeaders(token),
  };
  try {
    const apiResponse = await axios.post(apiEndpoint, payload, options);
    if ([401, 403].indexOf(apiResponse.status) !== -1) {
      return 403;
    }
    if ([200, 201].indexOf(apiResponse.data.statusCode) === -1) {
      return apiResponse;
    }
    return apiResponse?.data;
  } catch (e: any) {
    if ([401, 403].indexOf(e.response?.status) !== -1) {
      return 403;
    }
    return null;
  }
};
export const getReceiptIdAPI = async (payload: any, token: string) => {
  const apiEndpoint: any = getUrl(PARKING_PAYMENT_RECEIPT);
  const options = {
    headers: getCommonHeaders(token),
  };
  try {
    const apiResponse = await axios.post(apiEndpoint, payload, options);
    if ([401, 403].indexOf(apiResponse.status) !== -1) {
      return 403;
    }
    if ([200, 201].indexOf(apiResponse.data.statusCode) === -1) {
      return apiResponse;
    }
    return apiResponse?.data;
  } catch (e: any) {
    if ([401, 403].indexOf(e.response?.status) !== -1) {
      return 403;
    }
    return null;
  }
};

export const getPropertyJourneyDetails = async (payload: any, token: string) => {
  const apiEndpoint: any = getUrl(GET_PROPERTY_JOURNEY_DETAILS_ENPOINT);
  const options = {
    headers: getCommonHeaders(token),
  };
  try {
    payload.referenceId = store.getState().user?.account?.PersonEmail;
    const apiResponse = await axios.post(apiEndpoint, payload, options);
    if ([401, 403].indexOf(apiResponse.status) !== -1) {
      return 403;
    }
    if ([200, 201].indexOf(apiResponse.data.statusCode) === -1) {
      return apiResponse;
    }
    return apiResponse;
  } catch (e: any) {
    if ([401, 403].indexOf(e.response?.status) !== -1) {
      return 403;
    }
    return null;
  }
}

export const getPropertyInfo = async (unitId: string, token?: string) => {
  const apiEndpoint: any = getUrl(PROPERTY_SEARCH_ENPOINT);
  const options = {
    headers: getCommonHeaders(token),
  };
  try {
    const apiResponse = await axios.get(`${apiEndpoint}/${unitId}`, options);
    if ([401, 403].indexOf(apiResponse.status) !== -1) {
      return 403;
    }
    if ([200, 201].indexOf(apiResponse.data.statusCode) === -1) {
      return apiResponse;
    }
    return apiResponse;
  } catch (e: any) {
    if ([401, 403].indexOf(e.response?.status) !== -1) {
      return 403;
    }
    return null;
  }
};

/**
 * Retrieves property kiosk data for virtual tour functionality
 *
 * @param propertyId - Unique identifier for the property to fetch kiosk data for
 * @param token - Authentication token for API authorization (optional)
 * @returns Promise resolving to:
 *   - AxiosResponse with property kiosk data on success
 *   - 403 if authentication fails or access is forbidden
 *   - null if any other error occurs during the API call
 */
export const getPropertyKioskData = async (
  propertyId: string, 
  token?: string
) => {
  const apiEndpoint: string = getUrl(PROPERTY_JOURNEY_VIRTUAL_TOUR_ENPOINT);
  try {
    const apiResponse = await axios.get(`${apiEndpoint}/${propertyId}`, {
      headers: getCommonHeaders(token),
    });
    if ([401, 403].indexOf(apiResponse?.status) !== -1) {
      return 403;
    }
    if ([200, 201].indexOf(apiResponse?.data?.statusCode) !== -1) {
      
      return apiResponse?.data?.data;
    }
    return null;
  } catch (e: any) {
    if ([401, 403].indexOf(e.response?.status) !== -1) {
      return 403;
    }
    return null;
  }
};


/**
 * API to get appointment time slots
 *
 * @param payload - Payload containing filter parameters and date to fetch time slots for
 * @param token - Authentication token for API authorization
 * @returns Promise resolving to:
 *   - AxiosResponse with appointment time slots on success
 *   - 403 if authentication fails or access is forbidden
 *   - null if any other error occurs during the API call
 */
export const getAppointmentTimeSlots = async (
  payload: any,
  token: string
) => {
  payload.referenceId = store.getState().user?.account?.PersonEmail;
  const apiEndpoint: string = getUrl(GET_APPOINTMENT_TIME_SLOTS_ENPOINT);
  const options = {
    headers: getCommonHeaders(token),
  };
  try {
    const apiResponse = await axios.post(apiEndpoint, payload, options);
    if ([401, 403].indexOf(apiResponse.status) !== -1) {
      return 403;
    }
    if ([200, 201].indexOf(apiResponse.data.statusCode) !== -1) {
      return apiResponse.data.data;
    }
    return null;
  } catch (e: any) {
    if ([401, 403].indexOf(e.response?.status) !== -1) {
      return 403;
    }
    return null;
  }
};

/**
 * API to create an appointment
 *
 * @param payload - Payload containing appointment details
 * @param token - Authentication token for API authorization
 * @returns Promise resolving to:
 *   - AxiosResponse with appointment details on success
 *   - 403 if authentication fails or access is forbidden
 *   - null if any other error occurs during the API call
 */
export const createAppointment = async (
  payload: any,
  token: string
) => {
  payload.referenceId = store.getState().user?.account?.PersonEmail;
  const apiEndpoint: string = getUrl(CREATE_APPOINTMENT_ENPOINT);
  const options = {
    headers: getCommonHeaders(token),
  };
  try {
    const apiResponse = await axios.post(apiEndpoint, payload, options);
    if ([401, 403].indexOf(apiResponse.status) !== -1) {
      return 403;
    }
    if ([200, 201].indexOf(apiResponse.data.statusCode) !== -1) {
      return apiResponse.data.data;
    }
    return null;
  } catch (e: any) {
    if ([401, 403].indexOf(e.response?.status) !== -1) {
      return 403;
    }
    return null;
  }
};

export const rescheduleAppointment = async (
  payload: any,
  token: string
) => {
  payload.referenceId = store.getState().user?.account?.PersonEmail;
  const apiEndpoint: string = getUrl(RESCHEDULE_APPOINTMENT_ENPOINT);
  const options = {
    headers: getCommonHeaders(token),
  };
  try {
    const apiResponse = await axios.post(apiEndpoint, payload, options);
    if ([401, 403].indexOf(apiResponse.status) !== -1) {
      return 403;
    }
    if ([200, 201].indexOf(apiResponse.data.statusCode) !== -1) {
      return apiResponse.data.data;
    }
    return null;
  } catch (e: any) {
    if ([401, 403].indexOf(e.response?.status) !== -1) {
      return 403;
    }
    return null;
  }
};


export const getAppointmentDetails = async (
  payload: any,
  token: string
) => {
  payload.referenceId = store.getState().user?.account?.PersonEmail;
  const apiEndpoint: string = getUrl(GET_APPOINTMENT_DETAILS_ENPOINT);
  const options = {
    headers: getCommonHeaders(token),
  };
  try {
    const apiResponse = await axios.post(apiEndpoint, payload, options);
    if ([401, 403].indexOf(apiResponse.status) !== -1) {
      return 403;
    }
    if ([200, 201].indexOf(apiResponse.data.statusCode) !== -1) {
      return apiResponse.data.data;
    }
    return null;
  } catch (e: any) {
    if ([401, 403].indexOf(e.response?.status) !== -1) {
      return 403;
    }
    return null;
  }
};

export const getHomeOrientationFormOptions = async (apiRequestBody: any , token: string) =>{
  apiRequestBody.referenceId = store.getState().user?.account?.PersonEmail;
  const apiEndpoint: any = getUrl(HOME_ORIENTATION_FORM_OPTIONS_ENDPOINT);
  const options = {
    headers: getCommonHeaders(token),
  };
  try {
    const apiResponse = await axios.post(apiEndpoint, apiRequestBody, options);
    if ([401, 403].indexOf(apiResponse.status) !== -1) {
      return 403;
    }
    if ([400].indexOf(apiResponse.status) !== -1) {
      return apiResponse;
    }
    if ([200, 201].indexOf(apiResponse.data.statusCode) === -1) {
      return apiResponse;
    }
    return apiResponse;
  } catch (e: any) {
    if ([401, 403].indexOf(e.response?.status) !== -1) {
      return 403;
    }
    return null;
  }
};

export const cancelSalesOrder = async (apiRequestBody: any , token: string) =>{
  apiRequestBody.referenceId = store.getState().user?.account?.PersonEmail;
  const apiEndpoint: any = getUrl(CANCEL_SALES_ORDER_ENDPOINT);
  const options = {
    headers: getCommonHeaders(token),
  };
  try {
    const apiResponse = await axios.post(apiEndpoint, apiRequestBody, options);
    if ([401, 403].indexOf(apiResponse.status) !== -1) {
      return 403;
    }
    if ([400].indexOf(apiResponse.status) !== -1) {
      return apiResponse;
    }
    if ([200, 201].indexOf(apiResponse.data.statusCode) === -1) {
      return apiResponse;
    }
    return apiResponse;
  } catch (e: any) {
    if ([401, 403].indexOf(e.response?.status) !== -1) {
      return 403;
    }
    return null;
  }
};

export const markFTSkippedForDS = async (apiRequestBody: any, token: string) => {
  const apiEndpoint: any = getUrl(DIGITAL_SALES_SKIP_FASTTRACK_ENDPOINT);
  const options = {
    headers: getCommonHeaders(token),
  };
  try {
    const apiResponse = await axios.post(apiEndpoint, apiRequestBody, options);
    if ([401, 403].indexOf(apiResponse.status) !== -1) {
      return 403;
    }
    if ([200, 201].indexOf(apiResponse.data.statusCode) === -1) {
      return apiResponse;
    }
    return apiResponse;
  } catch (e: any) {
    if ([401, 403].indexOf(e.response?.status) !== -1) {
      return 403;
    }
    return null;
  }
}

export const getFasttrackKYBOptions = async () => {
  const apiEndpoint: any = getUrl(FASTTRACK_KYB_OPTIONS_ENDPOINT);
  try {
    const apiResponse = await axios.get(`${apiEndpoint}?v=${Date.now()}`);
    if ([401, 403].indexOf(apiResponse.status) !== -1) {
      return 403;
    }
    if ([200, 201].indexOf(apiResponse.data.statusCode) === -1) {
      return apiResponse;
    }
    return apiResponse;
  } catch (e: any) {
    if ([401, 403].indexOf(e.response?.status) !== -1) {
      return 403;
    }
    return null;
  }
};

export const saveFasttrackKYBForm = async (apiRequestBody: any , token: string) =>{
  const apiEndpoint: any = getUrl(FASTTRACK_SAVE_KYB_OPTIONS_ENDPOINT);
  const options = {
    headers: getCommonHeaders(token),
  };
  try {
    const apiResponse = await axios.post(apiEndpoint, apiRequestBody, options);
    if ([401, 403].indexOf(apiResponse.status) !== -1) {
      return 403;
    }
    if ([400].indexOf(apiResponse.status) !== -1) {
      return apiResponse;
    }
    if ([200, 201].indexOf(apiResponse.data.statusCode) === -1) {
      return apiResponse;
    }
    return apiResponse;
  } catch (e: any) {
    if ([401, 403].indexOf(e.response?.status) !== -1) {
      return 403;
    }
    return null;
  }
};

export const getFasttrackKYBDetails = async (apiRequestBody: any , token: string) =>{
  const apiEndpoint: any = getUrl(FASTTRACK_GET_KYB_OPTIONS_ENDPOINT);
  const options = {
    headers: getCommonHeaders(token),
  };
  try {
    const apiResponse = await axios.post(apiEndpoint, apiRequestBody, options);
    if ([401, 403].indexOf(apiResponse.status) !== -1) {
      return 403;
    }
    if ([400].indexOf(apiResponse.status) !== -1) {
      return apiResponse;
    }
    if ([200, 201].indexOf(apiResponse.data.statusCode) === -1) {
      return apiResponse;
    }
    return apiResponse;
  } catch (e: any) {
    if ([401, 403].indexOf(e.response?.status) !== -1) {
      return 403;
    }
    return null;
  }
};

export const createFasttrackForDS = async (apiRequestBody: any, token: string) => {
  const apiEndpoint: any = getUrl(DIGITAL_SALES_CREATE_FASTTRACK_ENDPOINT);
  const options = {
    headers: getCommonHeaders(token),
  };
  try {
    const apiResponse = await axios.post(apiEndpoint, apiRequestBody, options);
    if ([401, 403].indexOf(apiResponse.status) !== -1) {
      return 403;
    }
    if ([200, 201].indexOf(apiResponse.data.statusCode) === -1) {
      return apiResponse;
    }
    return apiResponse;
  } catch (e: any) {
    if ([401, 403].indexOf(e.response?.status) !== -1) {
      return 403;
    }
    return null;
  }
}

export const createCPRecord = async (apiRequestBody: any, token: string) => {
  const apiEndpoint: any = getUrl(DIGITAL_SALES_CREATE_CPRECORD_ENDPOINT);
  const options = {
    headers: getCommonHeaders(token),
  };
  try {
    const apiResponse = await axios.post(apiEndpoint, apiRequestBody, options);
    if ([401, 403].indexOf(apiResponse.status) !== -1) {
      return 403;
    }
    if ([200, 201].indexOf(apiResponse.data.statusCode) === -1) {
      return apiResponse;
    }
    return apiResponse;
  } catch (e: any) {
    if ([401, 403].indexOf(e.response?.status) !== -1) {
      return 403;
    }
    return null;
  }
}

export const getSalesManagers = async (token: string) => {
  const apiEndpoint: any = getUrl(DIGITAL_SALES_GET_SALESMANAGERS_ENDPOINT);
  const options = {
    headers: getCommonHeaders(token),
  };
  try {
    const apiResponse = await axios.get(apiEndpoint, options);
    if ([401, 403].indexOf(apiResponse.status) !== -1) {
      return 403;
    }
    if ([200, 201].indexOf(apiResponse.data.statusCode) === -1) {
      return apiResponse;
    }
    return apiResponse;
  } catch (e: any) {
    if ([401, 403].indexOf(e.response?.status) !== -1) {
      return 403;
    } 
    return null;
  }
}

export const updateOpportunityOwner = async (apiRequestBody: UpdateOpportunityOwnerPayloadType, token: string) => {
  const apiEndpoint: any = getUrl(DIGITAL_SALES_UPDATE_SALESMANAGER_ENDPOINT);
  const options = {
    headers: getCommonHeaders(token),
  };
  try {
    const apiResponse = await axios.post(apiEndpoint, apiRequestBody, options);
    if ([401, 403].indexOf(apiResponse.status) !== -1) {
      return 403;
    }
    if ([200, 201].indexOf(apiResponse.data.statusCode) === -1) {
      return apiResponse;
    }
    return apiResponse;
  } catch (e: any) {
    if ([401, 403].indexOf(e.response?.status) !== -1) {
      return 403;
    }
    return null;
  }
}

export const getUnitAvailability = async (apiRequestBody: GetUnitAvailabilityPayloadType, token: string) => {
  const apiEndpoint: any = getUrl(DIGITAL_SALES_UNIT_AVAILABILITY_ENDPOINT);
  const options = {
    headers: getCommonHeaders(token),
  };
  try {
    const apiResponse = await axios.post(apiEndpoint, apiRequestBody, options);
    if ([401, 403].indexOf(apiResponse.status) !== -1) {
      return 403;
    }
    if ([200, 201].indexOf(apiResponse.data.statusCode) === -1) {
      return apiResponse;
    }
    return apiResponse;
  } catch (e: any) {
    if ([401, 403].indexOf(e.response?.status) !== -1) {
      return 403;
    }
    return null;
  }
}

export const getShortlistedProperties = async (apiRequestBody: GetShortlistedPropertiesPayloadType, token: string) => {
  const apiEndpoint: any = getUrl(DIGITAL_SALES_SHORTLISTED_UNITS_ENDPOINT);
  const options = {
    headers: getCommonHeaders(token),
  };
  try {
    const apiResponse = await axios.post(apiEndpoint, apiRequestBody, options);
    if ([401, 403].indexOf(apiResponse.status) !== -1) {
      return 403;
    }
    if ([200, 201].indexOf(apiResponse.data.statusCode) === -1) {
      return apiResponse;
    }
    return apiResponse;
  } catch (e: any) {
    if ([401, 403].indexOf(e.response?.status) !== -1) {
      return 403;
    }
    return null;
  }
}

export const getDocumentList = async (apiRequestBody: GetDocumentListPayloadType, token: string) => {
  apiRequestBody.referenceId = store.getState().user?.account?.PersonEmail;
  const apiEndpoint: any = getUrl(GET_DOCUMENT_LIST_ENDPOINT);
  const options = {
    headers: getCommonHeaders(token),
  };
  try {
    const apiResponse = await axios.post(apiEndpoint, apiRequestBody, options);
    if ([401, 403].indexOf(apiResponse.status) !== -1) {
      return 403;
    }
    if ([200, 201].indexOf(apiResponse.data.statusCode) === -1) {
      return apiResponse;
    }
    return apiResponse;
  } catch (e: any) {
    if ([401, 403].indexOf(e.response?.status) !== -1) {
      return 403;
    }
    return null;
  }
}

export const deleteDocument = async (apiRequestBody: DeleteDocumentPayloadType, token: string) => {
  apiRequestBody.referenceId = store.getState().user?.account?.PersonEmail;
  const apiEndpoint: any = getUrl(DELETE_DOCUMENT_ENDPOINT);
  const options = {
    headers: getCommonHeaders(token),
  };
  try {
    const apiResponse = await axios.post(apiEndpoint, apiRequestBody, options);
    if ([401, 403].indexOf(apiResponse.status) !== -1) {
      return 403;
    }
    if ([200, 201].indexOf(apiResponse.data.statusCode) === -1) {
      return apiResponse;
    }
    return apiResponse;
  } catch (e: any) {
    if ([401, 403].indexOf(e.response?.status) !== -1) {
      return 403;
    }
    return null;
  }
}